(function () {
  'use strict';

  var root = document.querySelector('[data-cw-editor-root]');
  if (!root || typeof window.fabric === 'undefined') {
    return;
  }

  var canvasElement = document.getElementById('cw-editor-canvas');
  if (!canvasElement) {
    return;
  }

  var cfg = window.customwearProductCustomizer || {};
  var editorOptions = cfg.editorOptions || {};
  var ATTRIBUTE_KEYS = {
    color: ((editorOptions.colors && editorOptions.colors[0] && editorOptions.colors[0].attribute) || ''),
    size: ((editorOptions.sizes && editorOptions.sizes[0] && editorOptions.sizes[0].attribute) || '')
  };
  var defaultTextColor = '#ffffff';
  var selectedChoices = {};
  var selectedVariationId = 0;
  var editorQuantity = 1;
  var editorQuantityConfirmed = false;
  var cartHintHideTimer = null;
  var sizeTriggerValue = root.querySelector('[data-cw-size-trigger-value]');
  var qtyTriggerValue = root.querySelector('[data-cw-qty-trigger-value]');
  var qtyCustomWrap = root.querySelector('[data-cw-qty-custom-wrap]');
  var qtyCustomFields = root.querySelector('[data-cw-qty-custom-fields]');
  var qtyCustomInput = root.querySelector('[data-cw-qty-custom-input]');
  var notice = root.querySelector('[data-cw-editor-notice]');
  var summaryPrice = root.querySelector('.cw-design-editor__summary-row strong');
  var uploadModal = root.querySelector('[data-cw-upload-modal]');
  var productSheetModal = root.querySelector('[data-cw-product-sheet]');
  var productSheetOpenBtn = root.querySelector('[data-cw-tool="open-product-sheet"]');
  var productSheetColorLabel = root.querySelector('[data-cw-product-sheet-color-label]');
  var sizeGuideModal = root.querySelector('[data-cw-size-guide-modal]');
  var sizeGuideImage = root.querySelector('[data-cw-size-guide-image]');
  var sizeGuideEmpty = root.querySelector('[data-cw-size-guide-empty]');
  var uploadInput = root.querySelector('[data-cw-upload-input]');
  var uploadName = root.querySelector('[data-cw-upload-name]');
  var addMenu = root.querySelector('[data-cw-add-menu]');
  var textToolbar = root.querySelector('[data-cw-text-toolbar]');
  var textToolbarTrack = root.querySelector('[data-cw-text-toolbar-track]');
  var textSize = root.querySelector('[data-cw-text-size]');
  var textSizePxLabel = root.querySelector('[data-cw-text-size-px]');
  var toolbarColor = root.querySelector('[data-cw-toolbar-color]');
  var toolbarColorDot = root.querySelector('[data-cw-toolbar-color-dot]');
  var textColorPanel = root.querySelector('[data-cw-text-color-panel]');
  var textFontPanel = root.querySelector('[data-cw-text-font-panel]');
  var textPaletteView = root.querySelector('[data-cw-text-palette-view]');
  var customColorView = root.querySelector('[data-cw-custom-color-view]');
  var textColorValue = root.querySelector('[data-cw-text-color-value]');
  var customColorValue = root.querySelector('[data-cw-text-color-value-custom]');
  var customColorPicker = root.querySelector('[data-cw-custom-text-color]');
  var customColorSquare = root.querySelector('[data-cw-custom-color-square]');
  var customColorHandle = root.querySelector('[data-cw-custom-color-handle]');
  var customTextHex = root.querySelector('[data-cw-custom-text-hex]');
  var customColorPreview = root.querySelector('[data-cw-custom-color-preview]');
  var mobileTextPaletteView = root.querySelector('[data-cw-mobile-text-palette-view]');
  var mobileCustomColorView = root.querySelector('[data-cw-mobile-custom-color-view]');
  var mobileCustomColorValue = root.querySelector('[data-cw-mobile-text-color-value-custom]');
  var mobileCustomColorPicker = root.querySelector('[data-cw-mobile-custom-text-color]');
  var mobileCustomColorSquare = root.querySelector('[data-cw-mobile-custom-color-square]');
  var mobileCustomColorHandle = root.querySelector('[data-cw-mobile-custom-color-handle]');
  var mobileCustomTextHex = root.querySelector('[data-cw-mobile-custom-text-hex]');
  var mobileCustomColorPreview = root.querySelector('[data-cw-mobile-custom-color-preview]');
  var mobileTextSize = root.querySelector('[data-cw-mobile-text-size]');
  var mobileSizeValue = root.querySelector('[data-cw-mobile-size-value]');
  var mobileColorDot = root.querySelector('[data-cw-mobile-color-dot]');
  var mobileColorLabel = root.querySelector('[data-cw-mobile-color-label]');
  var desktopColorLabel = root.querySelector('[data-cw-desktop-color-label]');
  var undoStack = [];
  var redoStack = [];
  var customHue = 0;
  var customSat = 0;
  var customVal = 7;
  var viewStates = {};
  var currentViewKey = cfg.productImage || 'default';
  var productAreaRef = null;
  var printZoneRef = null;
  var currentPrintZoneMeta = null;
  var activePrintZonesMeta = [];
  var printZoneRefs = {};
  var productImageLoadRequested = false;
  var EDITOR_CANVAS_W = (cfg.printZones && cfg.printZones.canvas_ref && cfg.printZones.canvas_ref.width) || 1680;
  var EDITOR_CANVAS_H = (cfg.printZones && cfg.printZones.canvas_ref && cfg.printZones.canvas_ref.height) || 1860;
  var PRINT_DPI = 300;

  function printZonesEnabled() {
    return !!(cfg.printZones && cfg.printZones.enabled && cfg.printZones.views && cfg.printZones.views.length);
  }

  function getCurrentPrintViewIndex() {
    var gallery = cfg.productGallery || [];
    var key = cwViewKeyNorm(currentViewKey);
    var i;
    for (i = 0; i < gallery.length; i += 1) {
      if (cwViewKeyNorm(gallery[i].src) === key) {
        return i;
      }
    }
    if (typeof activeProductViewIndex === 'function') {
      return activeProductViewIndex();
    }
    return 0;
  }

  function resolveActivePrintZones() {
    if (!printZonesEnabled()) {
      return [];
    }
    var idx = getCurrentPrintViewIndex();
    var view = cfg.printZones.views[idx];
    if (!view || !view.breakpoints || !view.breakpoints.desktop) {
      return [];
    }
    var bpData = view.breakpoints.desktop;
    if (!bpData.zones || !bpData.zones.length) {
      return [];
    }
    return bpData.zones;
  }

  function resolveActivePrintZone() {
    var zones = resolveActivePrintZones();
    return zones.length ? zones[0] : null;
  }

  function getProductBoundsForZones() {
    if (productImageRef) {
      var b = productImageRef.getBoundingRect(true, true);
      if (b.width > 0 && b.height > 0) {
        return {
          left: b.left,
          top: b.top,
          width: b.width,
          height: b.height
        };
      }
    }
    return null;
  }

  function zonePixelsFromRelative(zone) {
    var angle = zone.angle || 0;
    var productRef = getProductBoundsForZones();
    if (zone.relative_to === 'product' && productRef) {
      return {
        left: productRef.left + zone.x * productRef.width,
        top: productRef.top + zone.y * productRef.height,
        width: zone.w * productRef.width,
        height: zone.h * productRef.height,
        angle: angle,
        shape: 'rect'
      };
    }
    return {
      left: zone.x * canvas.width,
      top: zone.y * canvas.height,
      width: zone.w * canvas.width,
      height: zone.h * canvas.height,
      angle: angle,
      shape: 'rect'
    };
  }

  function getZoneMetaForObject(obj) {
    if (!obj) {
      return currentPrintZoneMeta;
    }
    var zoneId = obj.cwAssignedZoneId;
    if (zoneId && activePrintZonesMeta.length) {
      var found = activePrintZonesMeta.find(function (z) {
        return z.id === zoneId;
      });
      if (found) {
        return found;
      }
    }
    return currentPrintZoneMeta;
  }

  function getZoneRefForObject(obj) {
    var meta = getZoneMetaForObject(obj);
    if (meta && printZoneRefs[meta.id]) {
      return printZoneRefs[meta.id];
    }
    return printZoneRef;
  }

  function printZoneConstraintsForObject(obj) {
    var meta = getZoneMetaForObject(obj);
    return (meta && meta.constraints) || {};
  }

  function printZoneLocksFont(obj) {
    var c = printZoneConstraintsForObject(obj);
    return !!c.disable_font;
  }

  function printZoneLocksColor(obj) {
    var c = printZoneConstraintsForObject(obj);
    return !!c.disable_color;
  }

  function isPrintZoneEditable(obj) {
    return obj && !obj.cwBackdrop && !obj.cwPrintZoneOverlay && !obj.excludeFromExport;
  }

  function printZoneAllowsText() {
    if (!currentPrintZoneMeta) {
      return true;
    }
    var type = currentPrintZoneMeta.type || 'both';
    return type === 'both' || type === 'text';
  }

  function printZoneAllowsImage() {
    if (!currentPrintZoneMeta) {
      return true;
    }
    var type = currentPrintZoneMeta.type || 'both';
    if (type !== 'both' && type !== 'image') {
      return false;
    }
    var c = currentPrintZoneMeta.constraints || {};
    if (c.one_image_only) {
      var hasUpload = canvas.getObjects().some(function (o) {
        return o && o.cwUserUpload;
      });
      if (hasUpload) {
        return false;
      }
    }
    return true;
  }

  function getPrintZonePlacementCenter() {
    if (printZoneRef) {
      return {
        left: printZoneRef.left + printZoneRef.width / 2,
        top: printZoneRef.top + printZoneRef.height / 2
      };
    }
    if (productAreaRef) {
      return {
        left: productAreaRef.left + productAreaRef.width / 2,
        top: productAreaRef.top + productAreaRef.height / 2
      };
    }
    return { left: canvas.width / 2, top: canvas.height / 2 };
  }

  function removePrintZoneOverlays() {
    canvas.getObjects().slice().forEach(function (obj) {
      if (obj && obj.cwPrintZoneOverlay) {
        canvas.remove(obj);
      }
    });
  }

  function applyPrintZoneClipPath(obj) {
    var z = getZoneRefForObject(obj);
    if (!z || !isPrintZoneEditable(obj)) {
      return;
    }
    obj.clipPath = new window.fabric.Rect({
      left: z.left,
      top: z.top,
      width: z.width,
      height: z.height,
      angle: z.angle || 0,
      absolutePositioned: true
    });
  }

  function applyPrintZoneLocks(obj) {
    if (!isPrintZoneEditable(obj)) {
      return;
    }
    var c = printZoneConstraintsForObject(obj);
    var lockMove = !!c.disable_move;
    var lockResize = !!c.disable_resize;
    var lockRotate = !!c.disable_rotate;
    // Tekst w strefie — zawsze można obracać; nadmiar obcina clipPath.
    if (isTextObject(obj)) {
      lockRotate = false;
    }
    obj.set({
      lockMovementX: lockMove,
      lockMovementY: lockMove,
      lockScalingX: lockResize,
      lockScalingY: lockResize,
      lockRotation: lockRotate,
      hasControls: true
    });
    if (isTextObject(obj) && typeof obj.setControlsVisibility === 'function') {
      obj.setControlsVisibility({
        cwRotate: !lockRotate,
        cwMove: !lockMove,
        mr: !lockResize,
        ml: !lockResize,
        tl: !lockResize
      });
    }
  }

  function constrainObjectToPrintZone(obj) {
    if (!obj || !isPrintZoneEditable(obj)) {
      return;
    }
    applyPrintZoneClipPath(obj);
  }

  function applyPrintZoneToEditableObject(obj) {
    if (currentPrintZoneMeta && !obj.cwAssignedZoneId) {
      obj.cwAssignedZoneId = currentPrintZoneMeta.id;
    }
    applyPrintZoneClipPath(obj);
    applyPrintZoneLocks(obj);
    constrainObjectToPrintZone(obj);
  }

  function elevateUserContentAbovePrintZoneOverlays() {
    editableObjects().forEach(function (obj) {
      canvas.bringToFront(obj);
    });
  }

  function renderPrintZoneOverlays(z) {
    canvas.add(new window.fabric.Rect({
      left: z.left,
      top: z.top,
      width: z.width,
      height: z.height,
      angle: (z.angle || 0),
      fill: 'rgba(255, 255, 255, 0.04)',
      stroke: 'rgba(255, 255, 255, 0.55)',
      strokeWidth: 1,
      strokeDashArray: [5, 4],
      selectable: false,
      evented: false,
      excludeFromExport: true,
      cwPrintZoneOverlay: true
    }));

    if (productImageRef) {
      canvas.sendToBack(productImageRef);
    }
    elevateUserContentAbovePrintZoneOverlays();
  }

  function syncPrintZones() {
    removePrintZoneOverlays();
    printZoneRef = null;
    currentPrintZoneMeta = null;
    activePrintZonesMeta = [];
    printZoneRefs = {};

    if (!printZonesEnabled()) {
      canvas.requestRenderAll();
      return;
    }

    var zones = resolveActivePrintZones();
    if (!zones.length) {
      canvas.requestRenderAll();
      return;
    }

    activePrintZonesMeta = zones;
    currentPrintZoneMeta = zones[0];
    zones.forEach(function (zone) {
      printZoneRefs[zone.id] = zonePixelsFromRelative(zone);
    });
    printZoneRef = printZoneRefs[zones[0].id];

    zones.forEach(function (zone) {
      renderPrintZoneOverlays(printZoneRefs[zone.id], zone);
    });

    editableObjects().forEach(function (obj) {
      applyPrintZoneToEditableObject(obj);
    });
    canvas.requestRenderAll();
  }

  var productImageRef = null;
  var canvas = new window.fabric.Canvas(canvasElement, {
    backgroundColor: 'transparent',
    preserveObjectStacking: true,
    selection: true,
    enableRetinaScaling: false,
    imageSmoothingEnabled: true,
    targetFindTolerance: 22,
    allowTouchScrolling: false
  });
  var editorDisplayCssW = EDITOR_CANVAS_W;
  var editorDisplayCssH = EDITOR_CANVAS_H;

  // Stałe DPR=1 — retina psuje skalę hit-testu (width attr vs bounds).
  canvas.getRetinaScaling = function () {
    return 1;
  };

  /** Offset z getBoundingClientRect — bez scroll/padding z getElementOffset (mobile). */
  canvas.calcOffset = function () {
    var el = this.upperCanvasEl || this.lowerCanvasEl;
    if (!el) {
      return this;
    }
    var rect = el.getBoundingClientRect();
    this._offset = { left: rect.left, top: rect.top };
    return this;
  };

  /** Pointer z clientX/Y — bez doliczania scroll (rozjeżdża się z visualViewport). */
  canvas.getPointer = function (e, ignoreZoom) {
    if (this._absolutePointer && !ignoreZoom) {
      return this._absolutePointer;
    }
    if (this._pointer && ignoreZoom) {
      return this._pointer;
    }
    var upperCanvasEl = this.upperCanvasEl;
    var bounds = upperCanvasEl.getBoundingClientRect();
    var boundsWidth = bounds.width || 0;
    var boundsHeight = bounds.height || 0;
    this.calcOffset();
    var touch =
      e && e.touches && e.touches[0]
        ? e.touches[0]
        : e && e.changedTouches && e.changedTouches[0]
          ? e.changedTouches[0]
          : e;
    var clientX = touch && typeof touch.clientX === 'number' ? touch.clientX : 0;
    var clientY = touch && typeof touch.clientY === 'number' ? touch.clientY : 0;
    var pointer = {
      x: clientX - this._offset.left,
      y: clientY - this._offset.top
    };
    if (!ignoreZoom) {
      pointer = this.restorePointerVpt(pointer);
    }
    var cssScale =
      !boundsWidth || !boundsHeight
        ? { width: 1, height: 1 }
        : {
            width: upperCanvasEl.width / boundsWidth,
            height: upperCanvasEl.height / boundsHeight
          };
    return {
      x: pointer.x * cssScale.width,
      y: pointer.y * cssScale.height
    };
  };
  if (window.fabric.IText && window.fabric.IText.prototype) {
    window.fabric.IText.prototype.objectCaching = false;
  }
  if (window.fabric.Text && window.fabric.Text.prototype) {
    window.fabric.Text.prototype.objectCaching = false;
  }
  if (window.fabric.Textbox && window.fabric.Textbox.prototype) {
    window.fabric.Textbox.prototype.objectCaching = false;
  }
  if (canvas.width !== EDITOR_CANVAS_W || canvas.height !== EDITOR_CANVAS_H) {
    canvas.setWidth(EDITOR_CANVAS_W);
    canvas.setHeight(EDITOR_CANVAS_H);
    canvasElement.width = EDITOR_CANVAS_W;
    canvasElement.height = EDITOR_CANVAS_H;
  }

  if (window.fabric.Text && window.fabric.Text.prototype) {
    window.fabric.Text.prototype.textBaseline = 'alphabetic';
  }
  if (window.fabric.IText && window.fabric.IText.prototype) {
    window.fabric.IText.prototype.textBaseline = 'alphabetic';
  }
  if (window.fabric.Textbox && window.fabric.Textbox.prototype) {
    window.fabric.Textbox.prototype.textBaseline = 'alphabetic';
  }

  function setupProductArea() {
    var areaLeft = canvas.width * 0.02;
    var areaTop = canvas.height * 0.02;
    var areaWidth = canvas.width * 0.96;
    var areaHeight = canvas.height * 0.96;
    productAreaRef = {
      left: areaLeft,
      top: areaTop,
      width: areaWidth,
      height: areaHeight
    };
  }

  function showProductAreaPlaceholder() {
    if (!productAreaRef) {
      setupProductArea();
    }
    var label = new window.fabric.Text(cfg.productName ? cfg.productName : 'Produkt', {
      left: canvas.width / 2,
      top: canvas.height * 0.5,
      originX: 'center',
      originY: 'center',
      fontSize: 18,
      fill: '#6b7280',
      selectable: false,
      evented: false,
      excludeFromExport: true
    });
    canvas.add(label);
    syncPrintZones();
    canvas.requestRenderAll();
    markEditorReady();
  }

  function ensureInitialProductImage() {
    if (!productAreaRef) {
      setupProductArea();
    }
    if (productImageLoadRequested) {
      return;
    }
    if (cfg.productImage) {
      setProductImageSrc(cfg.productImage);
      return;
    }
    showProductAreaPlaceholder();
  }

  function removeAllBackdropProductImages() {
    canvas.getObjects().slice().forEach(function (obj) {
      if (obj && obj.cwBackdrop) {
        canvas.remove(obj);
      }
    });
    productImageRef = null;
  }

  function dedupeBackdropProductImages() {
    var backs = canvas.getObjects().filter(function (o) {
      return o && o.cwBackdrop;
    });
    if (backs.length <= 1) {
      productImageRef = backs.length ? backs[0] : productImageRef;
      return;
    }
    var keep = backs[backs.length - 1];
    backs.slice(0, -1).forEach(function (obj) {
      canvas.remove(obj);
    });
    productImageRef = keep;
  }

  function markCanvasObjectsDirty() {
    if (!canvas || typeof canvas.getObjects !== 'function') {
      return;
    }
    canvas.getObjects().forEach(function (obj) {
      if (!obj) {
        return;
      }
      obj.dirty = true;
      if (typeof obj.set === 'function') {
        obj.set('dirty', true);
      }
    });
  }

  /** Zsynchronizuj offset wskazań z realnym getBoundingClientRect (mobile / fixed chrome). */
  function syncCanvasPointerOffset() {
    if (!canvas) {
      return;
    }
    try {
      canvas.calcOffset();
    } catch (eCalc) {}
  }

  /** Dopasuj wyświetlanie — cssOnly MUSI mieć jednostkę px (Fabric 5). */
  function syncEditorCanvasDisplayScale() {
    var wrap = root.querySelector('.cw-design-editor__canvas-wrap');
    var container = root.querySelector('.cw-design-editor__canvas-wrap .canvas-container');
    if (!container || !canvas) {
      return;
    }

    // Na mobile: najpierw policz dostępny box, wymuś jawny rozmiar kontenera.
    var isMobile = isMobileEditorViewport();
    var availW = (wrap && wrap.clientWidth) || container.clientWidth || window.innerWidth;
    var availH = (wrap && wrap.clientHeight) || container.clientHeight || window.innerHeight;
    if (isMobile && wrap) {
      availW = wrap.clientWidth || availW;
      availH = wrap.clientHeight || availH;
    }
    var aspect = EDITOR_CANVAS_H / EDITOR_CANVAS_W;
    var cssW = availW;
    var cssH = Math.round(cssW * aspect);
    if (cssH > availH && availH > 0) {
      cssH = availH;
      cssW = Math.round(cssH / aspect);
    }
    cssW = Math.max(2, Math.round(cssW));
    cssH = Math.max(2, Math.round(cssH));

    if (isMobile) {
      container.style.setProperty('width', cssW + 'px', 'important');
      container.style.setProperty('height', cssH + 'px', 'important');
      container.style.setProperty('max-width', cssW + 'px', 'important');
      container.style.setProperty('max-height', cssH + 'px', 'important');
      container.style.setProperty('aspect-ratio', 'auto', 'important');
    }

    editorDisplayCssW = cssW;
    editorDisplayCssH = cssH;

    canvas.setZoom(1);
    canvas.setViewportTransform([1, 0, 0, 1, 0, 0]);
    canvas.setDimensions({ width: EDITOR_CANVAS_W, height: EDITOR_CANVAS_H });
    // Fabric 5: przy cssOnly trzeba podać jednostkę — inaczej style.width="390" jest ignorowane.
    canvas.setDimensions({ width: cssW + 'px', height: cssH + 'px' }, { cssOnly: true });

    [canvas.lowerCanvasEl, canvas.upperCanvasEl, container].forEach(function (el) {
      if (!el || !el.style) {
        return;
      }
      el.style.setProperty('width', cssW + 'px', 'important');
      el.style.setProperty('height', cssH + 'px', 'important');
    });

    try {
      var ctx = canvas.getContext();
      if (ctx) {
        ctx.imageSmoothingEnabled = true;
        if ('imageSmoothingQuality' in ctx) {
          ctx.imageSmoothingQuality = 'high';
        }
      }
      if (canvas.contextTop) {
        canvas.contextTop.imageSmoothingEnabled = true;
        if ('imageSmoothingQuality' in canvas.contextTop) {
          canvas.contextTop.imageSmoothingQuality = 'high';
        }
      }
    } catch (eSmooth) {}
    markCanvasObjectsDirty();
    syncCanvasPointerOffset();
    canvas.requestRenderAll();
  }

  function fitProductImage(img) {
    if (!productAreaRef || !img) {
      return;
    }
    var w = Number(img.width) || 0;
    var h = Number(img.height) || 0;
    var el = typeof img.getElement === 'function' ? img.getElement() : img._element;
    if (el && (!w || !h)) {
      w = Number(el.naturalWidth) || w;
      h = Number(el.naturalHeight) || h;
      if (w > 0 && h > 0) {
        img.set({ width: w, height: h });
      }
    }
    if (!w || !h) {
      return;
    }
    // Desktop: −20% względem pełnego fit; mobile: prawie pełny obszar.
    var isDesktopEditor = window.matchMedia && window.matchMedia('(min-width: 901px)').matches;
    var areaFill = isDesktopEditor ? 0.784 : 0.98;
    var maxW = productAreaRef.width * areaFill;
    var maxH = productAreaRef.height * areaFill;
    var scale = Math.min(maxW / w, maxH / h);
    img.set({
      left: productAreaRef.left + productAreaRef.width / 2,
      top: productAreaRef.top + productAreaRef.height / 2,
      originX: 'center',
      originY: 'center',
      selectable: false,
      evented: false,
      hasControls: false,
      lockMovementX: true,
      lockMovementY: true,
      excludeFromExport: false,
      cwBackdrop: true,
      objectCaching: false
    });
    img.scale(scale);
    if (typeof img.setCoords === 'function') {
      img.setCoords();
    }
  }

  function markEditorReady() {
    if (root) {
      root.classList.add('cw-design-editor--ready');
    }
  }

  function setProductImageSrc(src, onReady) {
    if (!src) {
      if (typeof onReady === 'function') {
        onReady();
      }
      markEditorReady();
      return;
    }
    productImageLoadRequested = true;
    var readyCalled = false;
    function finish() {
      if (readyCalled) {
        return;
      }
      readyCalled = true;
      markEditorReady();
      if (typeof onReady === 'function') {
        try {
          onReady();
        } catch (errCb) {}
      }
    }
    window.fabric.Image.fromURL(src, function (img) {
      removeAllBackdropProductImages();
      productImageRef = img;
      fitProductImage(img);
      canvas.add(img);
      canvas.sendToBack(img);
      canvas.requestRenderAll();
      syncPrintZones();
      finish();
    }, { crossOrigin: 'anonymous' });
    window.setTimeout(finish, 12000);
  }

  function escapeHtml(value) {
    return String(value == null ? '' : value)
      .replace(/&/g, '&amp;')
      .replace(/</g, '&lt;')
      .replace(/>/g, '&gt;')
      .replace(/"/g, '&quot;')
      .replace(/'/g, '&#39;');
  }

  function variationPriceMarkup(variation) {
    if (!variation || typeof variation !== 'object') {
      return '';
    }
    if (variation.price_html) {
      return String(variation.price_html);
    }
    if (variation.display_price != null) {
      var numericDisplay = Number(variation.display_price);
      if (!isNaN(numericDisplay)) {
        return escapeHtml(numericDisplay.toFixed(2).replace('.', ',') + ' zł');
      }
    }
    if (variation.price != null) {
      var numericPrice = Number(variation.price);
      if (!isNaN(numericPrice)) {
        return escapeHtml(numericPrice.toFixed(2).replace('.', ',') + ' zł');
      }
    }
    return '';
  }

  function variationUnitPrice(variation) {
    if (!variation || typeof variation !== 'object') {
      return NaN;
    }
    if (variation.display_price != null) {
      var display = Number(variation.display_price);
      if (!isNaN(display)) {
        return display;
      }
    }
    if (variation.price != null) {
      var price = Number(variation.price);
      if (!isNaN(price)) {
        return price;
      }
    }
    return NaN;
  }

  function formatUnitPriceAmount(amount) {
    return escapeHtml(Number(amount).toFixed(2).replace('.', ',') + ' zł');
  }

  function updateSummaryPriceDisplay(variation) {
    if (!summaryPrice || !variation) {
      return;
    }
    var unitPrice = variationUnitPrice(variation);
    var qty = editorQuantityConfirmed ? editorQuantity : 1;
    if (!isNaN(unitPrice) && unitPrice > 0 && qty > 1) {
      summaryPrice.innerHTML = formatUnitPriceAmount(unitPrice * qty);
      return;
    }
    var priceMarkup = variationPriceMarkup(variation);
    if (priceMarkup) {
      summaryPrice.innerHTML = priceMarkup;
    }
  }

  function updateSelectedVariation(variation) {
    selectedVariationId = variation && variation.variation_id ? parseInt(variation.variation_id, 10) || 0 : 0;
    if (!variation) {
      return;
    }
    // Tylko cena/ID — bez podmiany tła (rozmiar nie może cofać aktywnego widoku galerii).
    updateSummaryPriceDisplay(variation);
  }

  function productNeedsColorChoice() {
    return (editorOptions.colors || []).length > 0;
  }

  function productNeedsSizeChoice() {
    return (editorOptions.sizes || []).length > 0;
  }

  function productNeedsQtyChoice() {
    return !!root.querySelector('[data-cw-editor-dropdown="qty"]');
  }

  function isColorSelected() {
    if (!productNeedsColorChoice()) {
      return true;
    }
    var colorKey = normalizeAttributeName(ATTRIBUTE_KEYS.color);
    if (!colorKey) {
      return false;
    }
    return !!normalizedSelectedChoices()[colorKey];
  }

  function isSizeSelected() {
    if (!productNeedsSizeChoice()) {
      return true;
    }
    var sizeKey = normalizeAttributeName(ATTRIBUTE_KEYS.size);
    if (!sizeKey) {
      return false;
    }
    return !!normalizedSelectedChoices()[sizeKey];
  }

  function isQuantitySelected() {
    if (!productNeedsQtyChoice()) {
      return true;
    }
    return editorQuantityConfirmed;
  }

  function getAddToCartHintMessage() {
    if (cfg.productType !== 'variable') {
      return '';
    }
    var i18n = cfg.i18n || {};
    var colorOk = isColorSelected();
    var sizeOk = isSizeSelected();
    var qtyOk = isQuantitySelected();
    if (colorOk && sizeOk && qtyOk) {
      return '';
    }
    if (!colorOk && !sizeOk && !qtyOk) {
      return i18n.chooseColorSizeAndQty || 'Wybierz kolor, rozmiar i ilość produktu.';
    }
    if (!colorOk && !sizeOk) {
      return i18n.chooseColorAndSize || 'Wybierz kolor i rozmiar produktu.';
    }
    if (!colorOk && !qtyOk) {
      return i18n.chooseColorAndQty || 'Wybierz kolor i ilość produktu.';
    }
    if (!sizeOk && !qtyOk) {
      return i18n.chooseSizeAndQty || 'Wybierz rozmiar i ilość produktu.';
    }
    if (!colorOk) {
      return i18n.chooseColor || 'Wybierz kolor produktu.';
    }
    if (!sizeOk) {
      return i18n.chooseSize || 'Wybierz rozmiar produktu.';
    }
    return i18n.chooseQty || 'Wybierz ilość produktu.';
  }

  function hideCartHints() {
    root.querySelectorAll('[data-cw-cart-hint]').forEach(function (hint) {
      hint.hidden = true;
      hint.classList.remove('is-visible');
    });
  }

  function showCartHints() {
    var message = getAddToCartHintMessage();
    if (!message) {
      hideCartHints();
      return;
    }
    root.querySelectorAll('[data-cw-cart-hint]').forEach(function (hint) {
      hint.textContent = message;
      hint.hidden = false;
      hint.classList.add('is-visible');
    });
    window.clearTimeout(cartHintHideTimer);
    cartHintHideTimer = window.setTimeout(hideCartHints, 4500);
  }

  function refreshAddToCartState() {
    var hint = getAddToCartHintMessage();
    var canAdd = false;

    if (cfg.productType !== 'variable') {
      canAdd = true;
    } else if (isColorSelected() && isSizeSelected() && isQuantitySelected() && selectedRequiredChoicesAreComplete()) {
      var variation = matchingVariation(true);
      canAdd = !!(variation && variationIsInStock(variation));
    }

    setAddToCartEnabled(canAdd);

    root.querySelectorAll('[data-cw-add-to-cart-btn]').forEach(function (btn) {
      var title = !canAdd && hint ? hint : '';
      if (title) {
        btn.setAttribute('title', title);
      } else {
        btn.removeAttribute('title');
      }
    });

    if (canAdd) {
      hideCartHints();
    }
  }

  function setAddToCartEnabled(enabled) {
    root.querySelectorAll('[data-cw-add-to-cart-btn]').forEach(function (btn) {
      var isEnabled = !!enabled;
      btn.disabled = false;
      btn.classList.toggle('is-disabled', !isEnabled);
      btn.setAttribute('aria-disabled', isEnabled ? 'false' : 'true');
    });
  }

  function setGroupActiveButton(button, selector) {
    root.querySelectorAll(selector).forEach(function (item) {
      item.classList.remove('is-active');
    });
    if (button) {
      button.classList.add('is-active');
    }
  }

  function variationChoiceValue(variation, kind) {
    var attrs = variation && variation.attributes ? variation.attributes : {};
    var keys = Object.keys(attrs);
    for (var i = 0; i < keys.length; i += 1) {
      var key = String(keys[i] || '').toLowerCase();
      var isColor = key.indexOf('kolor') !== -1 || key.indexOf('color') !== -1 || key.indexOf('colour') !== -1;
      var isSize = key.indexOf('rozmiar') !== -1 || key.indexOf('size') !== -1 || key.indexOf('wielko') !== -1;
      if ((kind === 'color' && isColor) || (kind === 'size' && isSize)) {
        return String(attrs[keys[i]] || '');
      }
    }
    return '';
  }

  function editableObjects() {
    return canvas.getObjects().filter(function (obj) {
      return obj && !obj.excludeFromExport && !obj.cwBackdrop && !obj.cwPrintZoneOverlay;
    });
  }

  function saveCurrentViewState() {
    var persistedProps = [
      'text',
      'fontFamily',
      'fontSize',
      'fontWeight',
      'fontStyle',
      'underline',
      'fill',
      'textAlign',
      'left',
      'top',
      'originX',
      'originY',
      'scaleX',
      'scaleY',
      'angle',
      'flipX',
      'flipY',
      'skewX',
      'skewY'
    ];
    var persistExtras = persistedProps.concat(['cwUserUpload', 'cwBackdrop', 'cwUserUploadDataUrl', 'cwUserUploadName', 'cwUserUploadType']);
    viewStates[currentViewKey] = editableObjects().map(function (obj) {
      return obj.toObject(persistExtras);
    });
  }

  function restoreViewState(viewKey) {
    editableObjects().forEach(function (obj) {
      canvas.remove(obj);
    });
    canvas.discardActiveObject();
    syncTextToolbar(null);
    undoStack = [];
    redoStack = [];

    var savedObjects = viewStates[viewKey] || [];
    if (!savedObjects.length) {
      syncPrintZones();
      canvas.requestRenderAll();
      return;
    }

    window.fabric.util.enlivenObjects(savedObjects, function (objects) {
      objects.forEach(function (obj) {
        /* Stare zapisy: duplikat mockupu jako image bez cwUserUpload — pomijamy */
        if (obj && obj.type === 'image' && !obj.cwUserUpload && !obj.cwBackdrop) {
          return;
        }
        if (obj && obj.cwBackdrop) {
          return;
        }
        normalizeCanvasTextBaseline(obj);
        if (isTextObject(obj)) {
          normalizeTextObjectFontSize(obj);
        }
        applyPrintZoneToEditableObject(obj);
        canvas.add(obj);
        obj.setCoords();
      });
      canvas.requestRenderAll();
      syncPrintZones();
    });
  }

  /** Zapis widoku — Promise po enliven (eksport wielu ujęć do koszyka). */
  function restoreViewStatePromise(viewKey) {
    return new Promise(function (resolve) {
      editableObjects().forEach(function (obj) {
        canvas.remove(obj);
      });
      canvas.discardActiveObject();
      syncTextToolbar(null);
      undoStack = [];
      redoStack = [];
      var savedObjects = viewStates[viewKey] || [];
      if (!savedObjects.length) {
        syncPrintZones();
        canvas.requestRenderAll();
        window.requestAnimationFrame(function () {
          window.setTimeout(resolve, 30);
        });
        return;
      }
      window.fabric.util.enlivenObjects(savedObjects, function (objects) {
        objects.forEach(function (obj) {
          if (obj && obj.type === 'image' && !obj.cwUserUpload && !obj.cwBackdrop) {
            return;
          }
          if (obj && obj.cwBackdrop) {
            return;
          }
          normalizeCanvasTextBaseline(obj);
          if (isTextObject(obj)) {
            normalizeTextObjectFontSize(obj);
          }
          applyPrintZoneToEditableObject(obj);
          canvas.add(obj);
          obj.setCoords();
        });
        canvas.requestRenderAll();
        syncPrintZones();
        window.requestAnimationFrame(function () {
          window.setTimeout(resolve, 40);
        });
      });
    });
  }

  function switchToViewKeyForExport(viewKey, done) {
    if (!viewKey) {
      done();
      return;
    }
    setProductImageSrc(viewKey, function () {
      currentViewKey = viewKey;
      restoreViewStatePromise(viewKey).then(function () {
        done();
      });
    });
  }

  function zoneMetaPhysical(zoneMeta) {
    return {
      widthMm: Math.max(10, Number(zoneMeta && zoneMeta.width_mm) || 300),
      heightMm: Math.max(10, Number(zoneMeta && zoneMeta.height_mm) || 400)
    };
  }

  function zonePxPerMmX(zoneRef, zoneMeta) {
    var phys = zoneMetaPhysical(zoneMeta);
    if (!zoneRef || !zoneRef.width || !phys.widthMm) {
      return EDITOR_CANVAS_W / phys.widthMm;
    }
    return zoneRef.width / phys.widthMm;
  }

  function zonePxPerMmY(zoneRef, zoneMeta) {
    var phys = zoneMetaPhysical(zoneMeta);
    if (!zoneRef || !zoneRef.height || !phys.heightMm) {
      return EDITOR_CANVAS_H / phys.heightMm;
    }
    return zoneRef.height / phys.heightMm;
  }

  /** @deprecated używaj zonePxPerMmX / zonePxPerMmY — strefa może mieć inny stosunek px/mm na osiach */
  function zonePxPerMm(zoneRef, zoneMeta) {
    return zonePxPerMmX(zoneRef, zoneMeta);
  }

  function pxToMmX(px, zoneRef, zoneMeta) {
    var ppm = zonePxPerMmX(zoneRef, zoneMeta);
    return ppm ? px / ppm : 0;
  }

  function pxToMmY(px, zoneRef, zoneMeta) {
    var ppm = zonePxPerMmY(zoneRef, zoneMeta);
    return ppm ? px / ppm : 0;
  }

  function pxToMm(px, zoneRef, zoneMeta) {
    return pxToMmX(px, zoneRef, zoneMeta);
  }

  function printTargetPixelSize(zoneMeta) {
    var phys = zoneMetaPhysical(zoneMeta);
    return {
      width: Math.max(1, Math.round((phys.widthMm / 25.4) * PRINT_DPI)),
      height: Math.max(1, Math.round((phys.heightMm / 25.4) * PRINT_DPI))
    };
  }

  /** Mnożnik kadru Fabric — wystarczająca rozdzielczość przed skalowaniem do docelowego 300 DPI. */
  function printCropMultiplier(zoneRef, zoneMeta) {
    var target = printTargetPixelSize(zoneMeta);
    if (!zoneRef || !zoneRef.width || !zoneRef.height) {
      return 4;
    }
    var multX = target.width / zoneRef.width;
    var multY = target.height / zoneRef.height;
    return Math.max(1.5, Math.min(14, Math.max(multX, multY, 3)));
  }

  function resizePngDataUrlToExact(dataUrl, targetW, targetH) {
    return new Promise(function (resolve) {
      if (!dataUrl || !targetW || !targetH) {
        resolve('');
        return;
      }
      var img = new Image();
      img.onload = function () {
        try {
          var c = document.createElement('canvas');
          c.width = targetW;
          c.height = targetH;
          var ctx = c.getContext('2d');
          if (!ctx) {
            resolve('');
            return;
          }
          ctx.clearRect(0, 0, targetW, targetH);
          ctx.imageSmoothingEnabled = true;
          ctx.imageSmoothingQuality = 'high';
          ctx.drawImage(img, 0, 0, targetW, targetH);
          resolve(c.toDataURL('image/png'));
        } catch (errResize) {
          resolve('');
        }
      };
      img.onerror = function () {
        resolve('');
      };
      img.src = dataUrl;
    });
  }

  function defaultFallbackExportZone() {
    if (!productAreaRef) {
      setupProductArea();
    }
    return {
      ref: productAreaRef || {
        left: canvas.width * 0.02,
        top: canvas.height * 0.02,
        width: canvas.width * 0.96,
        height: canvas.height * 0.96,
        angle: 0
      },
      meta: {
        id: 'zone_main',
        width_mm: 300,
        height_mm: 400,
        angle: 0
      }
    };
  }

  function zonesWithContentForExport() {
    var out = [];
    var zonesMeta = activePrintZonesMeta.length ? activePrintZonesMeta.slice() : [];
    if (!zonesMeta.length) {
      zonesMeta = [defaultFallbackExportZone().meta];
    }
    zonesMeta.forEach(function (meta) {
      var ref = printZoneRefs[meta.id] || printZoneRef;
      if (!ref) {
        return;
      }
      var has = editableObjects().some(function (obj) {
        var oMeta = getZoneMetaForObject(obj);
        return oMeta && oMeta.id === meta.id;
      });
      if (has) {
        out.push({ meta: meta, ref: ref });
      }
    });
    if (!out.length && editableObjects().length) {
      var fb = defaultFallbackExportZone();
      out.push(fb);
    }
    return out;
  }

  function layerFillHex(obj) {
    var fill = obj && obj.fill;
    if (fill == null) {
      return '';
    }
    if (typeof fill === 'object' && typeof fill.toHex === 'function') {
      try {
        return fill.toHex();
      } catch (errHex) {
        return String(fill);
      }
    }
    return String(fill);
  }

  function collectLayerProductionMeta(obj, zoneRef, zoneMeta, viewLabel) {
    if (!obj || !zoneRef) {
      return null;
    }
    var rect = obj.getBoundingRect(true, true);
    var relLeft = rect.left - zoneRef.left;
    var relTop = rect.top - zoneRef.top;
    var layer = {
      type: isTextObject(obj) ? 'text' : (obj.cwUserUpload ? 'image' : 'shape'),
      viewLabel: (viewLabel || '').trim(),
      zoneId: zoneMeta && zoneMeta.id ? String(zoneMeta.id) : '',
      zone_width_mm: zoneMetaPhysical(zoneMeta).widthMm,
      zone_height_mm: zoneMetaPhysical(zoneMeta).heightMm,
      width_mm: Math.round(pxToMmX(rect.width, zoneRef, zoneMeta) * 100) / 100,
      height_mm: Math.round(pxToMmY(rect.height, zoneRef, zoneMeta) * 100) / 100,
      offset_left_mm: Math.round(pxToMmX(Math.max(0, relLeft), zoneRef, zoneMeta) * 100) / 100,
      offset_top_mm: Math.round(pxToMmY(Math.max(0, relTop), zoneRef, zoneMeta) * 100) / 100,
      rotation_angle: Math.round((obj.angle || 0) * 100) / 100,
      width_px: Math.round(rect.width * 100) / 100,
      height_px: Math.round(rect.height * 100) / 100,
      offset_left_px: Math.round(relLeft * 100) / 100,
      offset_top_px: Math.round(relTop * 100) / 100
    };
    if (isTextObject(obj)) {
      layer.text = String(obj.text || '');
      layer.fontFamily = obj.fontFamily ? String(obj.fontFamily) : 'Quicksand';
      layer.fill = layerFillHex(obj);
      var fontPx = clampCwTextFontSize(getEffectiveTextFontPx(obj));
      layer.fontSize_px = Math.round(fontPx * 100) / 100;
      layer.fontSize_mm = Math.round(pxToMmY(fontPx, zoneRef, zoneMeta) * 100) / 100;
      layer.fontWeight = obj.fontWeight ? String(obj.fontWeight) : 'normal';
      layer.fontStyle = obj.fontStyle ? String(obj.fontStyle) : 'normal';
    }
    return layer;
  }

  function collectCurrentViewProductionLayers(viewLabel) {
    var layers = [];
    editableObjects().forEach(function (obj) {
      var zRef = getZoneRefForObject(obj);
      var zMeta = getZoneMetaForObject(obj);
      if (!zRef) {
        var fb = defaultFallbackExportZone();
        zRef = fb.ref;
        zMeta = fb.meta;
      }
      var row = collectLayerProductionMeta(obj, zRef, zMeta, viewLabel);
      if (row) {
        layers.push(row);
      }
    });
    return layers;
  }

  function createPrintExportSnapshot() {
    var snap = {
      backgroundColor: canvas.backgroundColor,
      backgroundImage: canvas.backgroundImage || null,
      hidden: []
    };
    canvas.getObjects().forEach(function (obj) {
      if (!obj) {
        return;
      }
      if (obj.cwBackdrop || obj.cwPrintZoneOverlay) {
        snap.hidden.push({ obj: obj, visible: obj.visible !== false });
        obj.set('visible', false);
      }
    });
    canvas.backgroundColor = 'transparent';
    if (canvas.backgroundImage) {
      snap.hadBackgroundImage = true;
      canvas.setBackgroundImage(null, canvas.requestRenderAll.bind(canvas));
      canvas.backgroundImage = null;
    }
    canvas.requestRenderAll();
    return snap;
  }

  function restorePrintExportSnapshot(snap) {
    if (!snap) {
      return;
    }
    canvas.backgroundColor = snap.backgroundColor;
    if (snap.hadBackgroundImage && snap.backgroundImage) {
      canvas.backgroundImage = snap.backgroundImage;
      canvas.setBackgroundImage(snap.backgroundImage, canvas.requestRenderAll.bind(canvas));
    }
    (snap.hidden || []).forEach(function (row) {
      if (row && row.obj) {
        row.obj.set('visible', row.visible);
      }
    });
    canvas.requestRenderAll();
  }

  function exportMockupDataUrl(multiView) {
    var hadPrintZones = printZonesEnabled() && activePrintZonesMeta.length > 0;
    var prevBg = canvas.backgroundColor;
    try {
      finalizeCanvasForRasterExport();
      removePrintZoneOverlays();
      if (productImageRef) {
        productImageRef.set('excludeFromExport', false);
      }
      // JPEG nie obsługuje przezroczystości — bez tego tło canvasu wychodzi czarne.
      canvas.backgroundColor = '#ffffff';
      canvas.requestRenderAll();
      var mult = multiView ? 1.15 : 1.35;
      var dataUrl = canvas.toDataURL({
        format: 'jpeg',
        quality: 0.82,
        multiplier: mult,
        enableRetinaScaling: false,
        filter: function (obj) {
          return !!(obj && !obj.cwPrintZoneOverlay);
        }
      });
      return typeof dataUrl === 'string' ? dataUrl : '';
    } catch (err) {
      return '';
    } finally {
      canvas.backgroundColor = prevBg;
      canvas.requestRenderAll();
      if (hadPrintZones) {
        syncPrintZones();
      }
    }
  }

  function exportPrintFileForZone(zoneRef, zoneMeta, done) {
    var callback = typeof done === 'function' ? done : function () {};
    if (!zoneRef || !zoneRef.width || !zoneRef.height) {
      callback('');
      return;
    }
    var hadPrintZones = printZonesEnabled() && activePrintZonesMeta.length > 0;
    var snap = null;
    var cropped = '';
    try {
      finalizeCanvasForRasterExport();
      removePrintZoneOverlays();
      snap = createPrintExportSnapshot();
      var mult = printCropMultiplier(zoneRef, zoneMeta);
      var raw = canvas.toDataURL({
        format: 'png',
        multiplier: mult,
        enableRetinaScaling: false,
        left: zoneRef.left,
        top: zoneRef.top,
        width: zoneRef.width,
        height: zoneRef.height,
        filter: function (obj) {
          return !!(obj && obj.visible !== false && isPrintZoneEditable(obj));
        }
      });
      cropped = typeof raw === 'string' ? raw : '';
    } catch (err) {
      cropped = '';
    } finally {
      restorePrintExportSnapshot(snap);
      if (hadPrintZones) {
        syncPrintZones();
      }
    }
    var target = printTargetPixelSize(zoneMeta);
    resizePngDataUrlToExact(cropped, target.width, target.height).then(function (finalUrl) {
      callback(finalUrl || '');
    });
  }

  function canvasToDataUrlForExport(multiView) {
    return exportMockupDataUrl(multiView);
  }

  function cwViewKeyNorm(k) {
    return String(k == null ? '' : k).trim();
  }

  function cwViewKeysEqual(a, b) {
    return cwViewKeyNorm(a) === cwViewKeyNorm(b);
  }

  /** Po przełączeniu widoku: poczekaj na fonty + 2× rAF zanim zrobisz toDataURL (inaczej PNG bywa bez napisów). */
  function schedulePostViewSwitchRasterCapture(fn) {
    var ran = false;
    function run() {
      if (ran) {
        return;
      }
      ran = true;
      try {
        canvas.requestRenderAll();
      } catch (eRr) {}
      fn();
    }
    window.setTimeout(run, 140);
    if (typeof document !== 'undefined' && document.fonts && document.fonts.ready && typeof document.fonts.ready.then === 'function') {
      document.fonts.ready
        .then(function () {
          window.requestAnimationFrame(function () {
            window.requestAnimationFrame(run);
          });
        })
        .catch(function () {});
    }
  }

  function exportAllEditedViewsForCart(done) {
    saveCurrentViewState();
    var summary = collectEditedProductViewsSummary();
    if (!summary.length) {
      done(null, []);
      return;
    }
    var startKey = currentViewKey;
    var results = [];
    var i = 0;
    var multi = summary.length > 1;
    var didSwitch = false;

    function restoreStart(cb) {
      if (!didSwitch || cwViewKeysEqual(currentViewKey, startKey)) {
        cb();
        return;
      }
      switchToViewKeyForExport(startKey, cb);
    }

    function captureRow(vk, lbl, rowDone) {
      var mockupDataUrl = exportMockupDataUrl(multi);
      var printFiles = [];
      var productionLayers = collectCurrentViewProductionLayers(lbl);
      var zones = zonesWithContentForExport();
      var zi = 0;

      function finishRow() {
        if (mockupDataUrl && mockupDataUrl.length <= 6 * 1024 * 1024) {
          results.push({
            label: lbl,
            mockupDataUrl: mockupDataUrl,
            dataUrl: mockupDataUrl,
            printFiles: printFiles,
            productionLayers: productionLayers
          });
        } else if (mockupDataUrl) {
          try {
            console.warn('cw_design_mockup: pominięte ujęcie — zbyt duży payload', { view: vk, length: mockupDataUrl.length });
          } catch (eW) {}
        }
        if (typeof rowDone === 'function') {
          rowDone();
        }
      }

      function nextZone() {
        if (zi >= zones.length) {
          finishRow();
          return;
        }
        var zRow = zones[zi];
        zi += 1;
        exportPrintFileForZone(zRow.ref, zRow.meta, function (printUrl) {
          if (printUrl && printUrl.length <= 6 * 1024 * 1024) {
            printFiles.push({
              zoneId: zRow.meta && zRow.meta.id ? String(zRow.meta.id) : 'zone',
              label: lbl,
              dataUrl: printUrl
            });
          } else if (printUrl) {
            try {
              console.warn('cw_design_print: pominięte ujęcie — zbyt duży payload', { view: vk, length: printUrl.length });
            } catch (eWp) {}
          }
          nextZone();
        });
      }

      nextZone();
    }

    function step() {
      if (i >= summary.length) {
        restoreStart(function () {
          done(null, results);
        });
        return;
      }
      var row = summary[i];
      var vk = row.src;
      var lbl = (row.label || '').trim();

      // Bieżący widok — łapiemy bezpośrednio aktualny canvas (napis i uploady są już na płótnie).
      // Unikamy destruktywnego switchToViewKeyForExport, który usuwa obiekty edycyjne i odtwarza je
      // async-em z viewStates — w razie potknięcia (timing / fonty) wynik wychodził goły.
      if (cwViewKeysEqual(vk, currentViewKey)) {
        captureRow(vk, lbl, function () {
          i += 1;
          step();
        });
        return;
      }

      didSwitch = true;
      switchToViewKeyForExport(vk, function () {
        schedulePostViewSwitchRasterCapture(function () {
          captureRow(vk, lbl, function () {
            i += 1;
            step();
          });
        });
      });
    }

    step();
  }

  function exitActiveTextEditing() {
    var editing = activeTextObject();
    if (!editing && canvas && typeof canvas.getActiveObject === 'function') {
      var active = canvas.getActiveObject();
      if (isTextObject(active)) {
        editing = active;
      }
    }
    if (editing && editing.isEditing && typeof editing.exitEditing === 'function') {
      try {
        editing.exitEditing();
      } catch (eExit) {}
    }
    canvas.getObjects().forEach(function (obj) {
      if (isTextObject(obj) && obj.isEditing && typeof obj.exitEditing === 'function') {
        try {
          obj.exitEditing();
        } catch (eExitAll) {}
      }
    });
  }

  function addText(options) {
    options = options || {};
    if (!printZoneAllowsText()) {
      setNotice(cfg.i18n && cfg.i18n.zoneTextOnly ? cfg.i18n.zoneTextOnly : 'W tym obszarze możesz dodać tylko napis.');
      return;
    }
    var openKeyboard = options.openKeyboard === true;
    var placement = getPrintZonePlacementCenter();
    var placeholder = cfg.i18n && cfg.i18n.placeholderText ? cfg.i18n.placeholderText : 'Edytuj tekst';
    var text = new window.fabric.IText(placeholder, {
      left: placement.left,
      top: placement.top,
      originX: 'center',
      originY: 'center',
      textAlign: 'center',
      textBaseline: 'middle',
      fontSize: defaultAddTextFontSize(),
      fill: defaultTextColor,
      fontFamily: 'Quicksand'
    });
    applyPrintZoneToEditableObject(text);
    canvas.add(text);
    centerTextInPrintZone(text);
    elevateUserContentAbovePrintZoneOverlays();
    undoStack.push({ type: 'add', object: text });
    redoStack = [];
    canvas.setActiveObject(text);
    syncTextToolbar(text);
    canvas.requestRenderAll();
    if (isMobileEditorViewport()) {
      switchTextTab('color');
      if (openKeyboard) {
        focusTextEditorInput(text);
      } else {
        window.setTimeout(function () {
          exitActiveTextEditing();
          try {
            canvas.calcOffset();
          } catch (eOff) {}
        }, 0);
      }
      return;
    }
    if (openKeyboard) {
      focusTextEditorInput(text);
    }
  }

  function focusTextEditorInput(text) {
    if (!text || !isTextObject(text) || typeof text.enterEditing !== 'function') {
      return;
    }
    canvas.setActiveObject(text);
    if (!text.isEditing) {
      text.enterEditing();
    }
    var input = text.hiddenTextarea;
    if (!input) {
      canvas.requestRenderAll();
      return;
    }
    input.classList.add('cw-fabric-text-input');
    input.setAttribute('inputmode', 'text');
    input.setAttribute('autocomplete', 'off');
    input.setAttribute('autocorrect', 'on');
    input.setAttribute('autocapitalize', 'sentences');
    input.setAttribute('enterkeyhint', 'done');
    input.removeAttribute('readonly');
    input.style.fontSize = '16px';
    if (!input._cwMobileLifecycleBound) {
      input._cwMobileLifecycleBound = true;
      input.addEventListener('focusout', function () {
        window.setTimeout(function () {
          try {
            canvas.calcOffset();
          } catch (eFocusOut) {}
        }, 280);
      });
    }
    try {
      input.focus({ preventScroll: true });
    } catch (ignored) {
      input.focus();
    }
    if (isMobileEditorViewport()) {
      try {
        input.click();
      } catch (ignoredClick) {}
    }
    canvas.requestRenderAll();
  }

  function startMobileTextWrite() {
    var active = activeTextObject();
    if (active) {
      focusTextEditorInput(active);
      syncTextToolbar(active);
      return;
    }
    addText({ openKeyboard: true });
  }

  function addShape() {
    var rect = new window.fabric.Rect({
      left: canvas.width / 2 - 60,
      top: canvas.height / 2 - 40,
      width: 120,
      height: 80,
      fill: '#111827'
    });
    canvas.add(rect);
    undoStack.push({ type: 'add', object: rect });
    redoStack = [];
    canvas.setActiveObject(rect);
    canvas.requestRenderAll();
  }

  function openUploadModal() {
    if (!uploadModal) {
      return;
    }
    uploadModal.hidden = false;
    document.body.classList.add('cw-upload-sheet-open');
    root.classList.add('cw-design-editor--upload-open');
    if (uploadInput && !isMobileEditorViewport()) {
      uploadInput.focus();
    }
  }

  function closeUploadModal() {
    if (uploadModal) {
      uploadModal.hidden = true;
    }
    document.body.classList.remove('cw-upload-sheet-open');
    root.classList.remove('cw-design-editor--upload-open');
    if (uploadInput) {
      uploadInput.value = '';
    }
    if (uploadName) {
      uploadName.textContent = 'lub przeciągnij i upuść tutaj';
    }
  }

  function openProductSheet() {
    if (!productSheetModal || !isMobileEditorViewport()) {
      return;
    }
    closeMobileTopClouds();
    closeUploadModal();
    productSheetModal.hidden = false;
    document.body.classList.add('cw-product-sheet-open');
    root.classList.add('cw-design-editor--product-sheet-open');
    if (productSheetOpenBtn) {
      productSheetOpenBtn.classList.add('is-active');
    }
  }

  function closeProductSheet() {
    if (productSheetModal) {
      productSheetModal.hidden = true;
    }
    document.body.classList.remove('cw-product-sheet-open');
    root.classList.remove('cw-design-editor--product-sheet-open');
    if (productSheetOpenBtn) {
      productSheetOpenBtn.classList.remove('is-active');
    }
  }

  function openSizeGuideModal() {
    if (!sizeGuideModal) {
      return;
    }
    closeProductSheet();
    var sizeGuideSrc = cfg.sizeGuideImage ? String(cfg.sizeGuideImage) : '';
    var defaultSizeGuideSrc = sizeGuideImage ? String(sizeGuideImage.getAttribute('data-default-src') || '') : '';
    if (sizeGuideImage) {
      var finalSrc = sizeGuideSrc || defaultSizeGuideSrc || '';
      if (finalSrc) {
        sizeGuideImage.src = finalSrc;
        sizeGuideImage.hidden = false;
        if (sizeGuideEmpty) {
          sizeGuideEmpty.hidden = true;
        }
      } else {
        sizeGuideImage.hidden = true;
        if (sizeGuideEmpty) {
          sizeGuideEmpty.hidden = false;
        }
      }
    }
    sizeGuideModal.hidden = false;
  }

  function closeSizeGuideModal() {
    if (sizeGuideModal) {
      sizeGuideModal.hidden = true;
    }
  }

  function closeAddMenu() {
    if (addMenu) {
      addMenu.hidden = true;
    }
  }

  function toggleAddMenu() {
    closeMobileTopClouds();
    if (addMenu) {
      addMenu.hidden = !addMenu.hidden;
    }
  }

  function addUploadedImage(dataUrl, fileMeta) {
    if (!printZoneAllowsImage()) {
      var imgMsg = cfg.i18n && cfg.i18n.zoneImageOnly ? cfg.i18n.zoneImageOnly : 'W tym obszarze możesz dodać tylko obraz.';
      if (currentPrintZoneMeta && currentPrintZoneMeta.constraints && currentPrintZoneMeta.constraints.one_image_only) {
        imgMsg = cfg.i18n && cfg.i18n.zoneOneImageOnly ? cfg.i18n.zoneOneImageOnly : imgMsg;
      }
      setNotice(imgMsg);
      closeUploadModal();
      return;
    }
    window.fabric.Image.fromURL(dataUrl, function (img) {
      var maxWidth = printZoneRef ? printZoneRef.width * 0.88 : canvas.width * 0.34;
      var maxHeight = printZoneRef ? printZoneRef.height * 0.88 : canvas.height * 0.34;
      var placement = getPrintZonePlacementCenter();
      var scale = Math.min(maxWidth / img.width, maxHeight / img.height, 1);
      img.set({
        left: placement.left,
        top: placement.top,
        originX: 'center',
        originY: 'center',
        borderColor: 'rgba(255,255,255,0.92)',
        borderDashArray: null,
        borderScaleFactor: 1.5,
        cornerColor: '#ffffff',
        cornerStrokeColor: '#0a0a0a',
        cornerStyle: 'circle',
        transparentCorners: false,
        cornerSize: 11,
        cwUserUpload: true,
        cwBackdrop: false,
        objectCaching: false
      });
      img.cwUserUploadDataUrl = dataUrl;
      img.cwUserUploadName = fileMeta && fileMeta.name ? String(fileMeta.name) : '';
      img.cwUserUploadType = fileMeta && fileMeta.type ? String(fileMeta.type) : '';
      img.scale(scale);
      applyPrintZoneToEditableObject(img);
      canvas.add(img);
      elevateUserContentAbovePrintZoneOverlays();
      undoStack.push({ type: 'add', object: img });
      redoStack = [];
      canvas.setActiveObject(img);
      canvas.requestRenderAll();
      closeUploadModal();
      setNotice('');
    });
  }

  function loadUploadedImage() {
    var file = uploadInput && uploadInput.files ? uploadInput.files[0] : null;
    if (!file || !file.type || file.type.indexOf('image/') !== 0) {
      setNotice('Wybierz plik graficzny PNG, JPG lub WEBP.');
      return;
    }

    var reader = new FileReader();
    reader.onload = function (event) {
      var result = event.target && event.target.result ? String(event.target.result) : '';
      if (result) {
        addUploadedImage(result, { name: file.name, type: file.type });
      }
    };
    reader.readAsDataURL(file);
  }

  function collectUserUploadOriginals() {
    if (!canvas || typeof canvas.getObjects !== 'function') {
      return [];
    }
    var out = [];
    var seen = {};
    canvas.getObjects().forEach(function (obj) {
      if (!obj || !obj.cwUserUpload || !obj.cwUserUploadDataUrl) {
        return;
      }
      var url = String(obj.cwUserUploadDataUrl);
      if (url.indexOf('data:image/') !== 0 || seen[url]) {
        return;
      }
      seen[url] = true;
      out.push({
        dataUrl: url,
        name: obj.cwUserUploadName ? String(obj.cwUserUploadName) : '',
        type: obj.cwUserUploadType ? String(obj.cwUserUploadType) : ''
      });
    });
    return out;
  }

  function withSelectedObject(cb) {
    var activeObject = canvas.getActiveObject();
    if (!activeObject) {
      window.alert(
        cfg.i18n && cfg.i18n.emptySelection
          ? cfg.i18n.emptySelection
          : 'Najpierw zaznacz element na canvasie.'
      );
      return;
    }
    cb(activeObject);
    canvas.requestRenderAll();
  }

  function undo() {
    var command = undoStack.pop();
    if (!command) {
      return;
    }
    if (command.type === 'add') {
      canvas.remove(command.object);
    }
    if (command.type === 'delete') {
      canvas.add(command.object);
    }
    redoStack.push(command);
    canvas.discardActiveObject();
    canvas.requestRenderAll();
  }

  function redo() {
    var command = redoStack.pop();
    if (!command) {
      return;
    }
    if (command.type === 'add') {
      canvas.add(command.object);
    }
    if (command.type === 'delete') {
      canvas.remove(command.object);
    }
    undoStack.push(command);
    canvas.discardActiveObject();
    canvas.requestRenderAll();
  }

  function isTextObject(obj) {
    return obj && (obj.type === 'i-text' || obj.type === 'text' || obj.type === 'textbox');
  }

  var CW_TEXT_FONT_MIN = 28;
  var CW_TEXT_FONT_MAX = 220;
  var cwTextSizeBakeGuard = false;

  function clampCwTextFontSize(px) {
    var n = Math.round(Number(px));
    if (isNaN(n)) {
      return 64;
    }
    return Math.max(CW_TEXT_FONT_MIN, Math.min(CW_TEXT_FONT_MAX, n));
  }

  /** Domyślny napis — mieści się w strefie (szer. i wys.), wyśrodkowany. */
  function defaultAddTextFontSize() {
    var zoneW = printZoneRef && printZoneRef.width ? printZoneRef.width : EDITOR_CANVAS_W * 0.28;
    var zoneH = printZoneRef && printZoneRef.height ? printZoneRef.height : EDITOR_CANVAS_H * 0.22;
    var label = cfg.i18n && cfg.i18n.placeholderText ? String(cfg.i18n.placeholderText) : 'Edytuj tekst';
    var chars = Math.max(label.length, 8);
    var fromHeight = zoneH * 0.2;
    var fromWidth = (zoneW * 0.88) / (chars * 0.58);
    return clampCwTextFontSize(Math.min(fromHeight, fromWidth));
  }

  /** Wyśrodkuj nowy tekst równo w siatce personalizacji. */
  function centerTextInPrintZone(text) {
    if (!text || !isTextObject(text)) {
      return;
    }
    var placement = getPrintZonePlacementCenter();
    text.set({
      left: placement.left,
      top: placement.top,
      originX: 'center',
      originY: 'center',
      textAlign: 'center',
      textBaseline: 'middle'
    });
    if (printZoneRef && printZoneRef.width > 0) {
      var maxW = printZoneRef.width * 0.9;
      var maxH = printZoneRef.height * 0.42;
      var fs = clampCwTextFontSize(text.fontSize);
      text.set({ fontSize: fs, scaleX: 1, scaleY: 1 });
      if (typeof text.initDimensions === 'function') {
        text.initDimensions();
      }
      var tw = text.getScaledWidth ? text.getScaledWidth() : text.width;
      var th = text.getScaledHeight ? text.getScaledHeight() : text.height;
      if (tw > maxW && tw > 0) {
        fs = clampCwTextFontSize(fs * (maxW / tw));
        text.set({ fontSize: fs });
        if (typeof text.initDimensions === 'function') {
          text.initDimensions();
        }
        th = text.getScaledHeight ? text.getScaledHeight() : text.height;
      }
      if (th > maxH && th > 0) {
        fs = clampCwTextFontSize((text.fontSize || fs) * (maxH / th));
        text.set({ fontSize: fs });
      }
      text.set({
        left: placement.left,
        top: placement.top,
        originX: 'center',
        originY: 'center'
      });
    }
    if (typeof text.setCoords === 'function') {
      text.setCoords();
    }
  }

  function formatMobileTextSizeLabel(px) {
    var n = clampCwTextFontSize(px);
    var span = CW_TEXT_FONT_MAX - CW_TEXT_FONT_MIN;
    var pct = span <= 0 ? 0 : Math.round(((n - CW_TEXT_FONT_MIN) / span) * 100);
    return pct + '%';
  }

  function getEffectiveTextFontPx(obj) {
    if (!obj || !isTextObject(obj)) {
      return CW_TEXT_FONT_MIN;
    }
    var fs = Number(obj.fontSize);
    if (isNaN(fs) || fs <= 0) {
      fs = 64;
    }
    var sx = Math.abs(obj.scaleX == null ? 1 : obj.scaleX);
    var sy = Math.abs(obj.scaleY == null ? 1 : obj.scaleY);
    return Math.round(fs * Math.max(sx, sy));
  }

  function normalizeTextObjectFontSize(obj) {
    if (!isTextObject(obj)) {
      return;
    }
    cwTextSizeBakeGuard = true;
    try {
      if (Math.abs((obj.scaleX || 1) - 1) > 0.001 || Math.abs((obj.scaleY || 1) - 1) > 0.001) {
        var eff = clampCwTextFontSize(getEffectiveTextFontPx(obj));
        obj.set({ fontSize: eff, scaleX: 1, scaleY: 1 });
        return;
      }
      var fs = clampCwTextFontSize(obj.fontSize);
      if (obj.fontSize !== fs) {
        obj.set('fontSize', fs);
      }
    } finally {
      cwTextSizeBakeGuard = false;
    }
  }

  /** Zserializowany obiekt Fabric (JSON) — warstwa tekstu */
  function isSavedTextLayerPlain(o) {
    return o && (o.type === 'i-text' || o.type === 'text' || o.type === 'textbox');
  }

  /** Rozmiar w px jak na canvasie (fontSize × skala) — dla payloadu zamówienia */
  function effectiveFontPxFromSavedLayer(o) {
    if (!o) {
      return CW_TEXT_FONT_MIN;
    }
    var fs = Number(o.fontSize);
    if (isNaN(fs) || fs <= 0) {
      fs = 64;
    }
    var sx = Math.abs(o.scaleX == null ? 1 : Number(o.scaleX));
    var sy = Math.abs(o.scaleY == null ? 1 : Number(o.scaleY));
    if (isNaN(sx)) {
      sx = 1;
    }
    if (isNaN(sy)) {
      sy = 1;
    }
    return clampCwTextFontSize(Math.round(fs * Math.max(sx, sy)));
  }

  function normalizeAllTextForOrderExport() {
    canvas.getObjects().forEach(function (obj) {
      if (!obj || obj.excludeFromExport || !isTextObject(obj)) {
        return;
      }
      normalizeTextObjectFontSize(obj);
    });
    saveCurrentViewState();
  }

  function removeObjectWithUndo(obj) {
    if (!obj || !canvas) {
      return;
    }
    undoStack.push({ type: 'delete', object: obj });
    redoStack = [];
    canvas.remove(obj);
    canvas.discardActiveObject();
    if (isTextObject(obj)) {
      syncTextToolbar(null);
    }
    canvas.requestRenderAll();
  }

  function applyCwItextFabricChrome() {
    var F = window.fabric;
    if (!F || !F.IText || !F.IText.prototype || !F.Control || !F.controlsUtils) {
      return;
    }
    var cu = F.controlsUtils;
    var src = F.Object.prototype.controls;
    var C = F.Control;
    /* Kontrola obiektu — czarno-biała, jak UI CustomWear (bez jaskrawego niebieskiego) */
    var INK = '#0a0a0a';
    var WHITE = '#ffffff';
    var DANGER = '#dc2626';
    // Mobile: canvas logiczny 1680 → mały CSS — uchwyty muszą być ~3.4× w px canvas, by były łapalne.
    var MS = window.matchMedia && window.matchMedia('(max-width: 900px)').matches ? 3.4 : 1;

    function drawToolButton(ctx, cx, cy, radius, fill, drawIcon) {
      ctx.save();
      ctx.beginPath();
      ctx.arc(cx, cy, radius + 1.25 * MS, 0, Math.PI * 2);
      ctx.fillStyle = 'rgba(255,255,255,0.92)';
      ctx.fill();
      ctx.beginPath();
      ctx.arc(cx, cy, radius, 0, Math.PI * 2);
      ctx.fillStyle = fill;
      ctx.fill();
      ctx.strokeStyle = 'rgba(255,255,255,0.95)';
      ctx.lineWidth = 1.25 * MS;
      ctx.stroke();
      ctx.strokeStyle = WHITE;
      ctx.fillStyle = WHITE;
      ctx.lineWidth = 1.7 * MS;
      ctx.lineCap = 'round';
      ctx.lineJoin = 'round';
      drawIcon(ctx, cx, cy, radius * 0.52);
      ctx.restore();
    }

    var mrPill = new C({
      x: 0.5,
      y: 0,
      actionHandler: cu.scalingXOrSkewingY,
      cursorStyleHandler: cu.scaleSkewCursorStyleHandler,
      getActionName: cu.scaleOrSkewActionName,
      sizeX: 9 * MS,
      sizeY: 22 * MS,
      touchSizeX: 32 * MS,
      touchSizeY: 48 * MS,
      render: function (ctx, left, top) {
        var rx = this.sizeX / 2;
        var ry = this.sizeY / 2;
        ctx.save();
        ctx.fillStyle = WHITE;
        ctx.strokeStyle = INK;
        ctx.lineWidth = 1.25 * MS;
        ctx.beginPath();
        if (typeof ctx.ellipse === 'function') {
          ctx.ellipse(left, top, rx, ry, 0, 0, Math.PI * 2);
        } else {
          ctx.arc(left, top, Math.max(rx, ry), 0, Math.PI * 2);
        }
        ctx.fill();
        ctx.stroke();
        ctx.restore();
      }
    });

    var mlPill = new C({
      x: -0.5,
      y: 0,
      actionHandler: cu.scalingXOrSkewingY,
      cursorStyleHandler: cu.scaleSkewCursorStyleHandler,
      getActionName: cu.scaleOrSkewActionName,
      sizeX: 9 * MS,
      sizeY: 22 * MS,
      touchSizeX: 32 * MS,
      touchSizeY: 48 * MS,
      render: function (ctx, left, top) {
        var rx = this.sizeX / 2;
        var ry = this.sizeY / 2;
        ctx.save();
        ctx.fillStyle = WHITE;
        ctx.strokeStyle = INK;
        ctx.lineWidth = 1.25 * MS;
        ctx.beginPath();
        if (typeof ctx.ellipse === 'function') {
          ctx.ellipse(left, top, rx, ry, 0, 0, Math.PI * 2);
        } else {
          ctx.arc(left, top, Math.max(rx, ry), 0, Math.PI * 2);
        }
        ctx.fill();
        ctx.stroke();
        ctx.restore();
      }
    });

    var cwDelete = new C({
      x: 0,
      y: -0.5,
      offsetY: -32 * MS,
      cursorStyle: 'pointer',
      sizeX: 22 * MS,
      sizeY: 22 * MS,
      touchSizeX: 48 * MS,
      touchSizeY: 48 * MS,
      actionName: 'cw-delete',
      mouseUpHandler: function (eventData, transform) {
        var target = transform && transform.target;
        if (target) {
          removeObjectWithUndo(target);
        }
        return true;
      },
      render: function (ctx, left, top) {
        drawToolButton(ctx, left, top, 10 * MS, DANGER, function (c, x, y, s) {
          var d = s * 0.72;
          c.lineWidth = 2 * MS;
          c.beginPath();
          c.moveTo(x - d, y - d);
          c.lineTo(x + d, y + d);
          c.moveTo(x + d, y - d);
          c.lineTo(x - d, y + d);
          c.stroke();
        });
      }
    });

    var cwRotate = new C({
      x: -0.5,
      y: 0.5,
      offsetX: 8 * MS,
      offsetY: 30 * MS,
      actionHandler: cu.rotationWithSnapping,
      cursorStyleHandler: cu.rotationStyleHandler,
      actionName: 'rotate',
      withConnection: false,
      sizeX: 24 * MS,
      sizeY: 24 * MS,
      touchSizeX: 52 * MS,
      touchSizeY: 52 * MS,
      render: function (ctx, left, top) {
        drawToolButton(ctx, left, top, 11 * MS, INK, function (c, x, y, s) {
          c.beginPath();
          c.arc(x, y, s, 0.3 * Math.PI, 1.9 * Math.PI);
          c.stroke();
          c.beginPath();
          c.moveTo(x + s * 0.5, y - s * 0.85);
          c.lineTo(x + s * 0.95, y - s * 0.4);
          c.lineTo(x + s * 0.35, y - s * 0.35);
          c.closePath();
          c.fill();
        });
      }
    });

    var cwMove = new C({
      x: 0.5,
      y: 0.5,
      offsetX: -8 * MS,
      offsetY: 30 * MS,
      actionHandler: cu.dragHandler,
      cursorStyle: 'move',
      actionName: 'move',
      sizeX: 24 * MS,
      sizeY: 24 * MS,
      touchSizeX: 52 * MS,
      touchSizeY: 52 * MS,
      render: function (ctx, left, top) {
        drawToolButton(ctx, left, top, 11 * MS, INK, function (c, x, y, s) {
          var d = s * 0.55;
          c.beginPath();
          c.moveTo(x, y - d);
          c.lineTo(x, y + d);
          c.moveTo(x - d, y);
          c.lineTo(x + d, y);
          c.stroke();
          c.beginPath();
          c.moveTo(x, y - d);
          c.lineTo(x - d * 0.35, y - d * 0.45);
          c.moveTo(x, y - d);
          c.lineTo(x + d * 0.35, y - d * 0.45);
          c.moveTo(x, y + d);
          c.lineTo(x - d * 0.35, y + d * 0.45);
          c.moveTo(x, y + d);
          c.lineTo(x + d * 0.35, y + d * 0.45);
          c.moveTo(x - d, y);
          c.lineTo(x - d * 0.45, y - d * 0.35);
          c.moveTo(x - d, y);
          c.lineTo(x - d * 0.45, y + d * 0.35);
          c.moveTo(x + d, y);
          c.lineTo(x + d * 0.45, y - d * 0.35);
          c.moveTo(x + d, y);
          c.lineTo(x + d * 0.45, y + d * 0.35);
          c.stroke();
        });
      }
    });

    var tlCorner = new C({
      x: -0.5,
      y: -0.5,
      actionHandler: cu.scalingEqually,
      cursorStyleHandler: cu.scaleCursorStyleHandler,
      actionName: 'scale',
      sizeX: 14 * MS,
      sizeY: 14 * MS,
      touchSizeX: 44 * MS,
      touchSizeY: 44 * MS,
      render: function (ctx, left, top) {
        var r = 6.5 * MS;
        ctx.save();
        ctx.beginPath();
        ctx.arc(left, top, r, 0, Math.PI * 2);
        ctx.fillStyle = WHITE;
        ctx.fill();
        ctx.strokeStyle = INK;
        ctx.lineWidth = 1.5 * MS;
        ctx.stroke();
        ctx.restore();
      }
    });

    F.IText.prototype.controls = Object.assign({}, src, {
      mr: mrPill,
      ml: mlPill,
      tl: tlCorner,
      cwDelete: cwDelete,
      cwRotate: cwRotate,
      cwMove: cwMove
    });

    F.IText.prototype.set({
      borderColor: 'rgba(255,255,255,0.92)',
      borderDashArray: null,
      borderScaleFactor: MS > 1 ? 2.25 : 1.5,
      padding: MS > 1 ? 14 : 6,
      cornerColor: WHITE,
      cornerStrokeColor: INK,
      transparentCorners: false,
      cornerStyle: 'circle',
      cornerSize: 11 * MS,
      touchCornerSize: 28 * MS,
      editingBorderColor: 'rgba(255,255,255,0.85)'
    });

    F.IText.prototype.setControlsVisibility({
      mt: false,
      mb: false,
      tr: false,
      br: false,
      bl: false,
      mtr: false,
      tl: true,
      mr: true,
      ml: true,
      cwDelete: true,
      cwRotate: true,
      cwMove: true
    });
  }

  applyCwItextFabricChrome();

  function normalizeCanvasTextBaseline(obj) {
    if (!isTextObject(obj) || !obj.textBaseline) {
      return;
    }
    if (obj.textBaseline === 'alphabetical') {
      obj.set('textBaseline', 'alphabetic');
    }
  }

  function normalizeAllCanvasTextBaselines() {
    canvas.getObjects().forEach(function (obj) {
      normalizeCanvasTextBaseline(obj);
    });
  }

  function syncTextToolbar(obj) {
    if (!textToolbar) {
      return;
    }
    if (!isTextObject(obj)) {
      textToolbar.hidden = true;
      root.classList.remove('cw-design-editor--text-open');
      if (textFontPanel) {
        textFontPanel.hidden = true;
      }
      if (textColorPanel) {
        textColorPanel.hidden = true;
      }
      window.requestAnimationFrame(function () {
        if (isMobileEditorViewport()) {
          syncEditorCanvasDisplayScale();
          if (productImageRef) {
            fitProductImage(productImageRef);
            syncPrintZones();
          }
        }
        syncCanvasPointerOffset();
      });
      return;
    }
    normalizeCanvasTextBaseline(obj);
    var px = clampCwTextFontSize(getEffectiveTextFontPx(obj));
    textToolbar.hidden = false;
    root.classList.add('cw-design-editor--text-open');
    window.requestAnimationFrame(function () {
      if (isMobileEditorViewport()) {
        syncEditorCanvasDisplayScale();
        if (productImageRef) {
          fitProductImage(productImageRef);
          syncPrintZones();
        }
      }
      syncCanvasPointerOffset();
    });
    if (textSize) {
      textSize.value = String(px);
      if (Number(textSize.min) !== CW_TEXT_FONT_MIN) {
        textSize.min = String(CW_TEXT_FONT_MIN);
      }
      if (Number(textSize.max) !== CW_TEXT_FONT_MAX) {
        textSize.max = String(CW_TEXT_FONT_MAX);
      }
    }
    if (mobileTextSize) {
      mobileTextSize.value = String(px);
      if (Number(mobileTextSize.min) !== CW_TEXT_FONT_MIN) {
        mobileTextSize.min = String(CW_TEXT_FONT_MIN);
      }
      if (Number(mobileTextSize.max) !== CW_TEXT_FONT_MAX) {
        mobileTextSize.max = String(CW_TEXT_FONT_MAX);
      }
    }
    if (mobileSizeValue) {
      mobileSizeValue.textContent = formatMobileTextSizeLabel(px);
    }
    if (textSizePxLabel) {
      textSizePxLabel.textContent = px + ' px';
    }
    if (toolbarColor && obj.fill) {
      toolbarColor.value = obj.fill;
    }
    if (toolbarColorDot && obj.fill) {
      toolbarColorDot.style.backgroundColor = obj.fill;
    }
    if (textColorValue && obj.fill) {
      textColorValue.textContent = obj.fill;
    }
    syncActiveTextSwatch(obj.fill || defaultTextColor);
    syncFontButtonLabel(obj);
    syncTextFormatControls(obj);
    updateTextToolbarNav();
  }

  function syncTextFormatControls(obj) {
    if (!obj || !isTextObject(obj)) {
      return;
    }
    var align = String(obj.textAlign || 'left').toLowerCase();
    if (align !== 'left' && align !== 'center' && align !== 'right') {
      align = 'left';
    }
    ['left', 'center', 'right'].forEach(function (side) {
      root.querySelectorAll('[data-cw-text-action="' + side + '"]').forEach(function (btn) {
        btn.classList.toggle('is-active', side === align);
      });
    });
    var fw = obj.fontWeight;
    var isBold = fw === 'bold' || fw === '700' || fw === 700;
    root.querySelectorAll('[data-cw-text-action="bold"]').forEach(function (btn) {
      btn.classList.toggle('is-active', isBold);
    });
    root.querySelectorAll('[data-cw-text-action="italic"]').forEach(function (btn) {
      btn.classList.toggle('is-active', obj.fontStyle === 'italic');
    });
    root.querySelectorAll('[data-cw-text-action="underline"]').forEach(function (btn) {
      btn.classList.toggle('is-active', !!obj.underline);
    });
  }

  function syncFontButtonLabel(obj) {
    if (!textToolbar) {
      return;
    }
    var label = textToolbar.querySelector('[data-cw-text-current-font]');
    if (!label) {
      return;
    }
    var family = obj && obj.fontFamily ? String(obj.fontFamily) : '';
    label.textContent = family !== '' ? family.split(',')[0].replace(/['"]/g, '').trim() : 'Font';
    root.querySelectorAll('[data-cw-font].cw-design-editor__text-font-tile').forEach(function (btn) {
      var f = (btn.getAttribute('data-cw-font') || '').trim();
      var cur = family !== '' ? family.split(',')[0].replace(/['"]/g, '').trim() : '';
      btn.classList.toggle('is-active', cur !== '' && f === cur);
    });
  }

  function updateTextToolbarNav() {
    if (!textToolbar || !textToolbarTrack) {
      return;
    }
    var prev = textToolbar.querySelector('[data-cw-text-nav="prev"]');
    var next = textToolbar.querySelector('[data-cw-text-nav="next"]');
    var max = textToolbarTrack.scrollWidth - textToolbarTrack.clientWidth;
    var x = textToolbarTrack.scrollLeft;
    var overflow = max > 4;
    if (prev) {
      prev.style.opacity = overflow && x > 4 ? '1' : '0';
      prev.style.visibility = overflow && x > 4 ? 'visible' : 'hidden';
    }
    if (next) {
      next.style.opacity = overflow && x < max - 4 ? '1' : '0';
      next.style.visibility = overflow && x < max - 4 ? 'visible' : 'hidden';
    }
  }

  function activeTextObject() {
    var activeObject = canvas.getActiveObject();
    return isTextObject(activeObject) ? activeObject : null;
  }

  function updateActiveText(updater) {
    var text = activeTextObject();
    if (!text) {
      return;
    }
    normalizeCanvasTextBaseline(text);
    updater(text);
    syncTextToolbar(text);
    canvas.requestRenderAll();
  }

  function hsvToHex(h, s, v) {
    var c = v * s;
    var x = c * (1 - Math.abs((h / 60) % 2 - 1));
    var m = v - c;
    var rgb = h < 60 ? [c, x, 0] : h < 120 ? [x, c, 0] : h < 180 ? [0, c, x] : h < 240 ? [0, x, c] : h < 300 ? [x, 0, c] : [c, 0, x];
    return '#' + rgb.map(function (part) {
      var value = Math.round((part + m) * 255).toString(16).toUpperCase();
      return value.length === 1 ? '0' + value : value;
    }).join('');
  }

  function updateCustomColorUi(color) {
    if (customColorValue) {
      customColorValue.textContent = color;
    }
    if (mobileCustomColorValue) {
      mobileCustomColorValue.textContent = color;
    }
    if (customTextHex) {
      customTextHex.value = color;
    }
    if (mobileCustomTextHex) {
      mobileCustomTextHex.value = color;
    }
    if (customColorPreview) {
      customColorPreview.style.backgroundColor = color;
    }
    if (mobileCustomColorPreview) {
      mobileCustomColorPreview.style.backgroundColor = color;
    }
    if (customColorSquare) {
      customColorSquare.style.backgroundColor = 'hsl(' + customHue + ', 100%, 50%)';
    }
    if (mobileCustomColorSquare) {
      mobileCustomColorSquare.style.backgroundColor = 'hsl(' + customHue + ', 100%, 50%)';
    }
    if (customColorHandle) {
      customColorHandle.style.left = customSat * 100 + '%';
      customColorHandle.style.top = (100 - customVal * 100) + '%';
    }
    if (mobileCustomColorHandle) {
      mobileCustomColorHandle.style.left = customSat * 100 + '%';
      mobileCustomColorHandle.style.top = (100 - customVal * 100) + '%';
    }
  }

  function applyTextColor(color) {
    var active = canvas.getActiveObject();
    if (isTextObject(active) && printZoneLocksColor(active)) {
      setNotice(cfg.i18n && cfg.i18n.zoneColorLocked ? cfg.i18n.zoneColorLocked : 'Wybór koloru jest wyłączony.');
      return;
    }
    defaultTextColor = color;
    if (toolbarColor) {
      toolbarColor.value = color;
    }
    if (toolbarColorDot) {
      toolbarColorDot.style.backgroundColor = color;
    }
    if (textColorValue) {
      textColorValue.textContent = color;
    }
    if (customColorValue) {
      customColorValue.textContent = color;
    }
    updateCustomColorUi(color);
    syncActiveTextSwatch(color);
    updateActiveText(function (text) {
      text.set('fill', color);
    });
  }

  function normalizeHexColor(value) {
    var color = (value || '').toString().trim().toLowerCase();
    if (!color) {
      return '';
    }
    if (/^#([0-9a-f]{3})$/.test(color)) {
      return '#' + color.charAt(1) + color.charAt(1) + color.charAt(2) + color.charAt(2) + color.charAt(3) + color.charAt(3);
    }
    return color;
  }

  function syncActiveTextSwatch(color) {
    var current = normalizeHexColor(color);
    root.querySelectorAll('[data-cw-text-swatch]').forEach(function (button) {
      var swatchColor = normalizeHexColor(button.getAttribute('data-cw-text-swatch') || '');
      button.classList.toggle('is-active', !!current && swatchColor === current);
    });
  }

  function switchTextTab(tabName) {
    if (!textToolbar || !tabName) {
      return;
    }
    textToolbar.querySelectorAll('[data-cw-text-tab]').forEach(function (item) {
      item.classList.toggle('is-active', item.getAttribute('data-cw-text-tab') === tabName);
    });
    textToolbar.querySelectorAll('[data-cw-text-panel]').forEach(function (panel) {
      var active = panel.getAttribute('data-cw-text-panel') === tabName;
      panel.hidden = !active;
      panel.classList.toggle('is-active', active);
    });
  }

  function isMobileEditorViewport() {
    return window.matchMedia && window.matchMedia('(max-width: 900px)').matches;
  }

  function applyCustomSquarePosition(event, square) {
    if (!square) {
      return;
    }
    var rect = square.getBoundingClientRect();
    customSat = Math.max(0, Math.min(1, (event.clientX - rect.left) / rect.width));
    customVal = Math.max(0, Math.min(1, 1 - (event.clientY - rect.top) / rect.height));
    applyTextColor(hsvToHex(customHue, customSat, customVal));
  }

  function setNotice(message) {
    if (!notice) {
      return;
    }
    notice.textContent = message || '';
    notice.hidden = !message;
  }

  function setActiveButton(button, selector) {
    root.querySelectorAll(selector).forEach(function (item) {
      item.classList.remove('is-active');
      item.style.outline = '';
      item.style.outlineOffset = '';
    });
    button.classList.add('is-active');
    button.style.outline = '2px solid #111827';
    button.style.outlineOffset = '2px';
  }

  function setMobileProductColor(hex, label) {
    if (mobileColorDot) {
      mobileColorDot.style.backgroundColor = hex || '#111827';
    }
    if (mobileColorLabel) {
      mobileColorLabel.textContent = label || 'Kolor';
    }
    if (desktopColorLabel) {
      desktopColorLabel.textContent = label || '—';
    }
    if (productSheetColorLabel) {
      productSheetColorLabel.textContent = label || '—';
    }
  }

  function showCustomColorView(inMobileSheet) {
    if (inMobileSheet) {
      if (mobileTextPaletteView) {
        mobileTextPaletteView.hidden = true;
      }
      if (mobileCustomColorView) {
        mobileCustomColorView.hidden = false;
      }
      return;
    }
    if (textPaletteView) {
      textPaletteView.hidden = true;
    }
    if (customColorView) {
      customColorView.hidden = false;
    }
  }

  function showPaletteView(inMobileSheet) {
    if (inMobileSheet) {
      if (mobileCustomColorView) {
        mobileCustomColorView.hidden = true;
      }
      if (mobileTextPaletteView) {
        mobileTextPaletteView.hidden = false;
      }
      return;
    }
    if (customColorView) {
      customColorView.hidden = true;
    }
    if (textPaletteView) {
      textPaletteView.hidden = false;
    }
  }

  function requiredChoiceAttributes() {
    var seen = {};
    var out = [];
    ['colors', 'sizes'].forEach(function (key) {
      (editorOptions[key] || []).forEach(function (item) {
        var normalized = normalizeAttributeName(item && item.attribute ? item.attribute : '');
        if (!normalized || seen[normalized]) {
          return;
        }
        seen[normalized] = true;
        out.push(normalized);
      });
    });
    return out;
  }

  function normalizedSelectedChoices() {
    var out = {};
    Object.keys(selectedChoices).forEach(function (name) {
      var normalizedName = normalizeAttributeName(name);
      if (!normalizedName) {
        return;
      }
      out[normalizedName] = selectedChoices[name];
    });
    return out;
  }

  function selectedRequiredChoicesAreComplete() {
    var current = normalizedSelectedChoices();
    var attrs = requiredChoiceAttributes();
    for (var i = 0; i < attrs.length; i += 1) {
      if (!current[attrs[i]]) {
        return false;
      }
    }
    return true;
  }

  function normalizeAttributeName(name) {
    var raw = (name || '').toString().trim().toLowerCase();
    if (!raw) {
      return '';
    }
    raw = raw.replace(/\s+/g, '_');
    return raw.indexOf('attribute_') === 0 ? raw : ('attribute_' + raw);
  }

  function attributeKeyCandidates(name) {
    var raw = (name || '').toString().trim();
    if (!raw) {
      return [];
    }
    var normalized = normalizeAttributeName(raw);
    var base = normalized.indexOf('attribute_') === 0 ? normalized.slice(10) : normalized;
    var baseNoPa = base.indexOf('pa_') === 0 ? base.slice(3) : base;
    var candidates = [
      raw,
      normalized,
      base,
      normalizeAttributeName(base),
      'pa_' + baseNoPa,
      normalizeAttributeName('pa_' + baseNoPa),
      baseNoPa,
      normalizeAttributeName(baseNoPa)
    ];
    var unique = [];
    candidates.forEach(function (candidate) {
      if (candidate && unique.indexOf(candidate) === -1) {
        unique.push(candidate);
      }
    });
    return unique;
  }

  function getVariationAttrValue(normalizedAttrs, name) {
    var keys = attributeKeyCandidates(name);
    for (var i = 0; i < keys.length; i += 1) {
      if (Object.prototype.hasOwnProperty.call(normalizedAttrs, keys[i])) {
        return normalizedAttrs[keys[i]];
      }
    }
    return '';
  }

  function normalizeAttributeValue(value) {
    var normalized = (value == null ? '' : String(value)).trim().toLowerCase();
    // Ujednolicenie etykiet i slugów (np. "Biały" vs "bialy").
    if (normalized && typeof normalized.normalize === 'function') {
      normalized = normalized.normalize('NFD').replace(/[\u0300-\u036f]/g, '');
    }
    return normalized.replace(/\s+/g, '-').replace(/_/g, '-');
  }

  function variationAttributesMap(variation) {
    var attrs = variation && variation.attributes ? variation.attributes : {};
    var normalizedAttrs = {};
    Object.keys(attrs).forEach(function (name) {
      var value = attrs[name];
      attributeKeyCandidates(name).forEach(function (candidate) {
        normalizedAttrs[candidate] = value;
      });
    });
    return normalizedAttrs;
  }

  function variationIsInStock(vr) {
    if (!vr) {
      return false;
    }
    if (vr.is_in_stock === false || vr.is_in_stock === 0 || vr.is_in_stock === 'false') {
      return false;
    }
    if (vr.is_purchasable === false || vr.is_purchasable === 0 || vr.is_purchasable === 'false') {
      return false;
    }
    return true;
  }

  function choiceIsAvailable(attribute, value) {
    var override = {};
    override[normalizeAttributeName(attribute)] = value;
    return matchesEditorChoices(override).some(variationIsInStock);
  }

  function refreshChoiceAvailability() {
    root.querySelectorAll('[data-cw-product-color], [data-cw-product-size]').forEach(function (button) {
      var attribute = button.getAttribute('data-cw-attribute') || '';
      var value = button.getAttribute('data-cw-value') || '';
      if (!attribute || !value) {
        return;
      }
      var show = choiceIsAvailable(attribute, value);
      button.hidden = !show;
      button.classList.remove('is-disabled', 'is-unavailable', 'cw-choice--oos');
      button.removeAttribute('aria-disabled');
      button.removeAttribute('title');
      button.removeAttribute('data-cw-unavailable-msg');
      button.removeAttribute('data-cw-oos-remind');
      var right = button.querySelector('[data-cw-choice-right]');
      if (right) {
        right.innerHTML = '';
      }
      if (!show && button.classList.contains('is-active')) {
        button.classList.remove('is-active');
        var key = normalizeAttributeName(attribute);
        Object.keys(selectedChoices).forEach(function (choiceKey) {
          if (normalizeAttributeName(choiceKey) === key) {
            delete selectedChoices[choiceKey];
          }
        });
      }
    });
  }

  function matchesEditorChoices(overrides) {
    var choices = normalizedSelectedChoices();
    if (overrides && typeof overrides === 'object') {
      Object.keys(overrides).forEach(function (key) {
        if (overrides[key]) {
          choices[normalizeAttributeName(key)] = overrides[key];
        }
      });
    }
    return (editorOptions.variations || []).filter(function (vr) {
      var normalizedAttrs = variationAttributesMap(vr);
      return Object.keys(choices).every(function (key) {
        var val = choices[key];
        if (!val) {
          return true;
        }
        var variationValue = getVariationAttrValue(normalizedAttrs, key);
        return normalizeAttributeValue(variationValue) === normalizeAttributeValue(val);
      });
    });
  }

  function matchingVariation(preferAvailable) {
    if (preferAvailable === undefined) {
      preferAvailable = true;
    }
    var variations = editorOptions.variations || [];
    var currentChoices = normalizedSelectedChoices();
    var fallback = null;
    for (var i = 0; i < variations.length; i += 1) {
      var variation = variations[i];
      var normalizedAttrs = variationAttributesMap(variation);
      var ok = true;
      Object.keys(currentChoices).forEach(function (name) {
        if (!ok) {
          return;
        }
        var normalizedName = normalizeAttributeName(name);
        var selectedValue = currentChoices[normalizedName];
        if (!selectedValue) {
          return;
        }
        var variationValue = getVariationAttrValue(normalizedAttrs, normalizedName);
        // Pusty atrybut w Woo = „Any” / atrybut tylko do UI (np. jeden kolor bez wariantów koloru).
        if (!variationValue) {
          return;
        }
        if (normalizeAttributeValue(variationValue) !== normalizeAttributeValue(selectedValue)) {
          ok = false;
        }
      });
      if (ok) {
        if (variationIsInStock(variation) || !preferAvailable) {
          return variation;
        }
        fallback = fallback || variation;
      }
    }
    return fallback;
  }

  function updateActiveVariant() {
    var previewVariation = matchingVariation(false);
    if (previewVariation) {
      updateSelectedVariation(previewVariation);
    } else {
      updateSelectedVariation(null);
    }

    var variation = matchingVariation(true);
    if (variation && variationIsInStock(variation)) {
      updateSelectedVariation(variation);
      setNotice('');
    } else {
      setNotice('');
    }

    refreshAddToCartState();
    return variation && variationIsInStock(variation) ? variation : (previewVariation || null);
  }

  function encodeParams(params) {
    var parts = [];
    Object.keys(params).forEach(function (key) {
      parts.push(encodeURIComponent(key) + '=' + encodeURIComponent(String(params[key])));
    });
    return parts.join('&');
  }

  function designTextSummary() {
    var texts = [];
    canvas.getObjects().forEach(function (obj) {
      if (!obj.excludeFromExport && isTextObject(obj) && obj.text) {
        texts.push(String(obj.text));
      }
    });
    return texts.join(' / ');
  }

  function isGenericViewLabel(label, viewIndex) {
    var t = String(label || '').trim();
    if (!t) {
      return true;
    }
    var n = Number(viewIndex) + 1;
    return new RegExp('^Widok\\s+' + n + '$', 'i').test(t) || new RegExp('^View\\s+' + n + '$', 'i').test(t);
  }

  function viewLabelFromPrintZones(viewIndex) {
    if (!printZonesEnabled()) {
      return '';
    }
    var views = cfg.printZones.views;
    if (!views || !views[viewIndex]) {
      return '';
    }
    var label = String(views[viewIndex].label || '').trim();
    if (isGenericViewLabel(label, viewIndex)) {
      return '';
    }
    return label;
  }

  function galleryLabelForViewKey(viewKey) {
    var key = viewKey == null ? '' : String(viewKey);
    var g = cfg.productGallery || [];
    var i = 0;
    for (; i < g.length; i += 1) {
      if (!g[i]) {
        continue;
      }
      if (String(g[i].src || '') === key) {
        var fromPrintZones = viewLabelFromPrintZones(i);
        if (fromPrintZones) {
          return fromPrintZones;
        }
        return String(g[i].label || '');
      }
    }
    /* Fallback dla pierwszego zdjęcia z konfiguracji */
    if (cfg.productImage && key === String(cfg.productImage)) {
      return '';
    }
    return '';
  }

  function normalizeColorLookupKey(value) {
    return String(value || '')
      .trim()
      .toLowerCase()
      .normalize('NFD')
      .replace(/[\u0300-\u036f]/g, '')
      .replace(/[^a-z0-9]+/g, '-')
      .replace(/^-+|-+$/g, '');
  }

  function fallbackGalleryIndexForColor(colorValue) {
    var colors = editorOptions.colors || [];
    var norm = normalizeColorLookupKey(colorValue);
    var previewSrc = '';
    var i = 0;
    for (; i < colors.length; i += 1) {
      var row = colors[i];
      if (!row) {
        continue;
      }
      var val = String(row.value || '');
      if (
        normalizeAttributeValue(val) === normalizeAttributeValue(colorValue)
        || normalizeColorLookupKey(val) === norm
      ) {
        previewSrc = String(row.image || '');
        break;
      }
    }
    if (previewSrc === '') {
      return [0];
    }
    var gallery = cfg.productGallery || [];
    var j = 0;
    for (; j < gallery.length; j += 1) {
      if (!gallery[j]) {
        continue;
      }
      if (String(gallery[j].src || '') === previewSrc || String(gallery[j].thumb || '') === previewSrc) {
        return [j];
      }
    }
    return [0];
  }

  function resolveGalleryIndicesForColor(colorValue) {
    var groups = cfg.colorSlideGroups || {};
    var raw = String(colorValue || '').trim();
    if (!raw) {
      return null;
    }
    var candidates = [raw, raw.toLowerCase(), normalizeColorLookupKey(raw)];
    var i = 0;
    for (; i < candidates.length; i += 1) {
      var key = candidates[i];
      if (key && Array.isArray(groups[key]) && groups[key].length > 0) {
        return groups[key].map(Number);
      }
    }
    var fromAlt = slideIndicesFromViewAlt(raw);
    if (fromAlt.length > 0) {
      return fromAlt;
    }
    return fallbackGalleryIndexForColor(raw);
  }

  function slideIndicesFromViewAlt(colorValue) {
    var stems = [];
    var slug = normalizeColorLookupKey(colorValue);
    if (slug) {
      stems.push(slug);
      if (slug.charAt(slug.length - 1) === 'y') {
        stems.push(slug.slice(0, -1) + 'a');
      }
      if (slug.charAt(slug.length - 1) === 'a') {
        stems.push(slug.slice(0, -1) + 'y');
      }
    }
    var colorStemMap = {
      bialy: ['bial', 'biala', 'white'],
      czarny: ['czarn', 'czarna', 'black'],
      niebieski: ['niebies', 'niebieska', 'blue'],
      szary: ['szar', 'szara', 'grey', 'gray'],
      granat: ['granat', 'granatowa', 'navy'],
      czerwony: ['czerw', 'czerwona', 'red']
    };
    if (colorStemMap[slug]) {
      stems = stems.concat(colorStemMap[slug]);
    }
    var out = [];
    root.querySelectorAll('[data-cw-product-view][data-cw-gallery-index]').forEach(function (btn) {
      var alt = String(btn.getAttribute('data-cw-slide-alt') || '').toLowerCase();
      if (!alt) {
        return;
      }
      var idx = parseInt(btn.getAttribute('data-cw-gallery-index'), 10);
      if (isNaN(idx)) {
        return;
      }
      var j = 0;
      for (; j < stems.length; j += 1) {
        if (stems[j] && alt.indexOf(stems[j]) !== -1) {
          if (out.indexOf(idx) === -1) {
            out.push(idx);
          }
          break;
        }
      }
    });
    return out;
  }

  function visibleProductViewButtons() {
    return Array.prototype.slice.call(root.querySelectorAll('[data-cw-product-view]')).filter(function (btn) {
      return !btn.hidden;
    });
  }

  function filterProductViewsByColor(colorValue) {
    var viewsWrap = root.querySelector('.cw-design-editor__views');
    if (!viewsWrap) {
      return;
    }
    var indices = resolveGalleryIndicesForColor(colorValue);
    var allowed = indices === null ? null : new Set(indices);
    var buttons = root.querySelectorAll('[data-cw-product-view]');
    var dots = root.querySelectorAll('.cw-design-editor__view-dots span');
    var firstVisible = null;
    var visibleCount = 0;

    buttons.forEach(function (btn, loopIdx) {
      var galleryIdx = parseInt(btn.getAttribute('data-cw-gallery-index'), 10);
      if (isNaN(galleryIdx)) {
        galleryIdx = loopIdx;
      }
      var show = !allowed || allowed.has(galleryIdx);
      btn.hidden = !show;
      if (show) {
        visibleCount += 1;
        if (!firstVisible) {
          firstVisible = btn;
        }
      } else {
        btn.classList.remove('is-active');
      }
    });

    dots.forEach(function (dot, dotIdx) {
      dot.hidden = !!(allowed && !allowed.has(dotIdx));
      if (dot.hidden) {
        dot.classList.remove('is-active');
      }
    });

    viewsWrap.classList.toggle('cw-design-editor__views--solo', visibleCount <= 1);

    if (firstVisible) {
      var activeVisible = visibleProductViewButtons().some(function (btn) {
        return btn.classList.contains('is-active');
      });
      if (!activeVisible) {
        firstVisible.click();
      } else {
        syncViewDots();
      }
    }
  }

  function parseViewLabelFromButton(viewKey) {
    var buttons = root.querySelectorAll('[data-cw-product-view][data-cw-src]');
    var k = viewKey == null ? '' : String(viewKey);
    var j = 0;
    for (; j < buttons.length; j += 1) {
      var b = buttons[j];
      var s = String(b.getAttribute('data-cw-src') || '');
      if (s === k) {
        var lbl = b.getAttribute('data-cw-view-label') || '';
        if (!lbl && b.querySelector('span')) {
          lbl = (b.querySelector('span').textContent || '').trim();
        }
        return lbl;
      }
    }
    return '';
  }

  function collectEditedProductViewsSummary() {
    saveCurrentViewState();
    var out = [];
    var seen = {};
    Object.keys(viewStates).forEach(function (k) {
      var objs = viewStates[k];
      if (!objs || !objs.length) {
        return;
      }
      if (seen[k]) {
        return;
      }
      seen[k] = true;
      var fromGallery = galleryLabelForViewKey(k);
      var fromDom = parseViewLabelFromButton(k);
      var label = (fromGallery || fromDom || '').trim();
      out.push({ src: String(k), label: label });
    });
    return out;
  }

  function pushTextLayerFromFabricObject(obj, out) {
    if (!obj || obj.excludeFromExport || !isTextObject(obj) || !obj.text) {
      return;
    }
    var txt = String(obj.text).trim();
    if (!txt) {
      return;
    }
    var fill = obj.fill;
    if (fill != null && typeof fill === 'object' && typeof fill.toHex === 'function') {
      try {
        fill = fill.toHex();
      } catch (errHex) {
        fill = String(fill);
      }
    }
    var px = clampCwTextFontSize(getEffectiveTextFontPx(obj));
    out.push({
      text: String(obj.text),
      fontFamily: obj.fontFamily ? String(obj.fontFamily) : 'Quicksand',
      fill: fill != null ? String(fill) : '',
      fontSize: Math.round(px * 100) / 100,
      fontWeight: obj.fontWeight ? String(obj.fontWeight) : 'normal',
      fontStyle: obj.fontStyle ? String(obj.fontStyle) : 'normal'
    });
  }

  function collectDesignTextLayers() {
    var out = [];
    canvas.getObjects().forEach(function (obj) {
      pushTextLayerFromFabricObject(obj, out);
    });
    return out;
  }

  /** Wszystkie widoki z edycją — rozmiary zgodne z wizualnym (skala → px), dla druku / meta zamówienia */
  function collectAllEditedViewsTextLayers(summaryArg) {
    var out = [];
    var summary = summaryArg || collectEditedProductViewsSummary();
    summary.forEach(function (row) {
      var objs = viewStates[row.src] || [];
      objs.forEach(function (o) {
        if (!o || o.excludeFromExport || !isSavedTextLayerPlain(o)) {
          return;
        }
        var txt = String(o.text || '').trim();
        if (!txt) {
          return;
        }
        var fill = o.fill;
        if (fill != null && typeof fill === 'object') {
          fill = String(fill);
        }
        var px = effectiveFontPxFromSavedLayer(o);
        out.push({
          text: String(o.text),
          fontFamily: o.fontFamily ? String(o.fontFamily) : 'Quicksand',
          fill: fill != null ? String(fill) : '',
          fontSize: Math.round(px * 100) / 100,
          fontWeight: o.fontWeight ? String(o.fontWeight) : 'normal',
          fontStyle: o.fontStyle ? String(o.fontStyle) : 'normal',
          viewLabel: (row.label || '').trim()
        });
      });
    });
    return out;
  }

  function applyCartFragments(fragments) {
    if (!fragments || typeof fragments !== 'object' || typeof window.jQuery === 'undefined') {
      return;
    }
    window.jQuery.each(fragments, function (key, value) {
      var $targets = window.jQuery(key);
      if ($targets.length) {
        $targets.replaceWith(value);
      }
    });
  }

  function setAddToCartButtonsBusy(busy) {
    root.querySelectorAll('[data-cw-add-to-cart-btn]').forEach(function (btn) {
      btn.disabled = !!busy;
      btn.classList.toggle('is-busy', !!busy);
    });
  }

  function debugAddToCart(stage, details) {
    try {
      console.groupCollapsed('[CW add_to_cart][' + stage + ']');
      console.log(details || {});
      console.groupEnd();
    } catch (err) {}
  }

  function finalizeCanvasForRasterExport() {
    canvas.getObjects().forEach(function (obj) {
      if (!obj || typeof obj.exitEditing !== 'function') {
        return;
      }
      try {
        obj.exitEditing();
      } catch (errExit) {}
    });
    canvas.discardActiveObject();
    canvas.requestRenderAll();
  }

  function buildDesignImagePayload() {
    var dataUrl = canvasToDataUrlForExport(false);
    if (!dataUrl) {
      return '';
    }
    if (dataUrl.length > 7 * 1024 * 1024) {
      console.warn('cw_design_image pominięte — payload zbyt duży', { length: dataUrl.length });
      return '';
    }
    return dataUrl;
  }

  function addToCart(button) {
    var hint = getAddToCartHintMessage();
    if (hint) {
      showCartHints();
      setNotice(hint);
      return;
    }

    if (cfg.productType === 'variable' && !selectedRequiredChoicesAreComplete()) {
      setNotice(cfg.i18n && cfg.i18n.chooseRequiredOptions ? cfg.i18n.chooseRequiredOptions : 'Wybierz dostępny kolor i rozmiar produktu.');
      return;
    }

    setAddToCartButtonsBusy(true);
    setNotice('');

    // WC AJAX endpoint (wc-ajax=add_to_cart) rozpoznaje wariant tylko gdy product_id w POST to ID wariantu
    // (variation post); variation_id z POST ani atrybuty nie są tam czytane przez rdzeń Woo.
    var params = {
      quantity: editorQuantity,
      product_id: cfg.productId
    };
    normalizeAllTextForOrderExport();
    var designText = designTextSummary();
    var editedViewsSummary = collectEditedProductViewsSummary();
    if (designText) {
      params.cw_design_text = designText;
    }
    if (cfg.designNonce) {
      params.cw_design_nonce = String(cfg.designNonce);
    }
    var variation = cfg.productType === 'variable' ? updateActiveVariant() : null;
    if (cfg.productType === 'variable') {
      if (!variation || !variationIsInStock(variation)) {
        console.error('Brak dostępnego wariantu do koszyka', {
          selectedChoices: selectedChoices,
          requiredComplete: selectedRequiredChoicesAreComplete(),
          variation: variation
        });
        setNotice(cfg.i18n && cfg.i18n.addToCartError ? cfg.i18n.addToCartError : 'Nie udało się dodać projektu do koszyka.');
        setAddToCartButtonsBusy(false);
        return;
      }
      updateSelectedVariation(variation);
      var vid = selectedVariationId || variation.variation_id;
      params.product_id = vid;
    }

    debugAddToCart('before-send', {
      productId: cfg.productId,
      productType: cfg.productType,
      selectedVariationId: selectedVariationId,
      requiredAttributes: requiredChoiceAttributes(),
      selectedChoices: selectedChoices,
      variation: variation,
      paramsPreview: {
        product_id: params.product_id,
        product_id_sent: params.product_id,
        attributes: Object.keys(params).filter(function (k) { return k.indexOf('attribute_') === 0; }).reduce(function (acc, k) {
          acc[k] = params[k];
          return acc;
        }, {}),
        cw_design_image_length: params.cw_design_image ? String(params.cw_design_image).length : 0
      }
    });

    if (typeof window.wc_add_to_cart_params === 'undefined' || !window.wc_add_to_cart_params.wc_ajax_url) {
      setAddToCartButtonsBusy(false);
      window.location = cfg.cartUrl || '/koszyk/';
      return;
    }

    function sendAddToCartRequest(exportBundle) {
      exportBundle = exportBundle || {};
      var mockups = exportBundle.mockups || [];
      var printFiles = exportBundle.printFiles || [];
      var productionLayers = exportBundle.productionLayers || [];
      params.cw_design_image = mockups[0] && mockups[0].dataUrl ? mockups[0].dataUrl : '';
      try {
        var mockupJson = mockups.length ? JSON.stringify(mockups) : '';
        params.mockup_file = mockupJson;
        params.cw_design_mockups_json = mockupJson;
      } catch (errM) {
        params.mockup_file = '';
        params.cw_design_mockups_json = '';
      }
      try {
        var printJson = printFiles.length ? JSON.stringify(printFiles) : '';
        params.custom_print_file = printJson;
        params.cw_design_print_files_json = printJson;
      } catch (errP) {
        params.custom_print_file = '';
        params.cw_design_print_files_json = '';
      }
      try {
        params.cw_design_images_json = mockups.length > 1 ? JSON.stringify(mockups) : '';
      } catch (errJ) {
        params.cw_design_images_json = '';
      }
      try {
        params.cw_design_payload = JSON.stringify({
          selectedChoices: selectedChoices,
          designText: designText,
          view: currentViewKey,
          textLayers: collectAllEditedViewsTextLayers(editedViewsSummary),
          editedProductViews: editedViewsSummary,
          cartAddedViewLabel: galleryLabelForViewKey(currentViewKey) || parseViewLabelFromButton(currentViewKey) || '',
          productionLayers: productionLayers,
          printSpec: {
            dpi: PRINT_DPI,
            fixedPrintSize: true,
            canvasRef: { width: EDITOR_CANVAS_W, height: EDITOR_CANVAS_H }
          }
        });
      } catch (errPayload) {
        params.cw_design_payload = '';
      }
      try {
        var originals = collectUserUploadOriginals();
        params.cw_design_user_uploads_json = originals.length > 0 ? JSON.stringify(originals) : '';
      } catch (errUpl) {
        params.cw_design_user_uploads_json = '';
      }
      var xhr = new XMLHttpRequest();
      xhr.open('POST', window.wc_add_to_cart_params.wc_ajax_url.replace('%%endpoint%%', 'add_to_cart'), true);
      xhr.setRequestHeader('Content-Type', 'application/x-www-form-urlencoded; charset=UTF-8');
      xhr.onreadystatechange = function () {
        if (xhr.readyState !== 4) {
          return;
        }
        setAddToCartButtonsBusy(false);
        var response = null;
        try {
          response = JSON.parse(xhr.responseText);
        } catch (err) {
          response = null;
        }
        if (xhr.status < 200 || xhr.status >= 300 || !response || response.error) {
          console.error('add_to_cart odrzucone', {
            status: xhr.status,
            response: response,
            rawResponse: xhr.responseText,
            payload: params
          });
          debugAddToCart('rejected', {
            status: xhr.status,
            response: response,
            productUrl: response && response.product_url ? response.product_url : '',
            selectedChoices: selectedChoices,
            selectedVariationId: selectedVariationId,
            payloadAttributes: Object.keys(params).filter(function (k) { return k.indexOf('attribute_') === 0; }).reduce(function (acc, k) {
              acc[k] = params[k];
              return acc;
            }, {}),
            variationIdInPayload: params.product_id || null,
            cwDesignImageLength: params.cw_design_image ? String(params.cw_design_image).length : 0
          });
          setNotice(cfg.i18n && cfg.i18n.addToCartError ? cfg.i18n.addToCartError : 'Nie udało się dodać projektu do koszyka.');
          return;
        }
        applyCartFragments(response.fragments);
        if (typeof window.jQuery !== 'undefined') {
          // Bez przycisku — WC inaczej dokleja „Zobacz koszyk” pod Koszyk w bottom-nav.
          window.jQuery(document.body).trigger('added_to_cart', [response.fragments, response.cart_hash, null]);
        }
        root.querySelectorAll('a.added_to_cart').forEach(function (link) {
          link.remove();
        });
        window.location = cfg.cartUrl || '/koszyk/';
      };
      xhr.send(encodeParams(params));
    }

    exportAllEditedViewsForCart(function (errExport, stackRows) {
      if (errExport) {
        setAddToCartButtonsBusy(false);
        setNotice(cfg.i18n && cfg.i18n.addToCartError ? cfg.i18n.addToCartError : 'Nie udało się dodać projektu do koszyka.');
        return;
      }
      var mockups = [];
      var printFiles = [];
      var productionLayers = [];
      (stackRows || []).forEach(function (row) {
        if (!row) {
          return;
        }
        var mockUrl = row.mockupDataUrl || row.dataUrl || '';
        if (mockUrl) {
          mockups.push({ label: row.label || '', dataUrl: mockUrl });
        }
        (row.printFiles || []).forEach(function (pf) {
          if (pf && pf.dataUrl) {
            printFiles.push({
              label: pf.label || row.label || '',
              zoneId: pf.zoneId || '',
              dataUrl: pf.dataUrl
            });
          }
        });
        if (row.productionLayers && row.productionLayers.length) {
          productionLayers = productionLayers.concat(row.productionLayers);
        }
      });
      if (!mockups.length) {
        var fallback = buildDesignImagePayload();
        if (fallback) {
          mockups.push({ label: '', dataUrl: fallback });
        }
      }
      sendAddToCartRequest({
        mockups: mockups,
        printFiles: printFiles,
        productionLayers: productionLayers
      });
    });
  }

  function handleChoiceClick(button, groupSelector, afterSelect) {
    if (!button) {
      return;
    }
    button.addEventListener('click', function () {
      var attribute = normalizeAttributeName(button.getAttribute('data-cw-attribute') || '');
      var value = button.getAttribute('data-cw-value')
        || button.getAttribute('data-cw-color')
        || button.getAttribute('data-cw-size')
        || '';
      var type = button.hasAttribute('data-cw-product-color') ? 'color' : (button.hasAttribute('data-cw-product-size') ? 'size' : '');
      var attrKey = attribute || (type && ATTRIBUTE_KEYS[type] ? normalizeAttributeName(ATTRIBUTE_KEYS[type]) : '');
      if (value && attrKey) {
        selectedChoices[attrKey] = value;
      }

      if (type === 'color' && attrKey) {
        var sizeKey = normalizeAttributeName(ATTRIBUTE_KEYS.size);
        var selectedSize = sizeKey ? String(normalizedSelectedChoices()[sizeKey] || '') : '';
        if (sizeKey && selectedSize) {
          var stillValid = (editorOptions.variations || []).some(function (row) {
            var normalizedAttrs = variationAttributesMap(row);
            return normalizeAttributeValue(getVariationAttrValue(normalizedAttrs, attrKey)) === normalizeAttributeValue(value)
              && normalizeAttributeValue(getVariationAttrValue(normalizedAttrs, sizeKey)) === normalizeAttributeValue(selectedSize);
          });
          if (!stillValid) {
            Object.keys(selectedChoices).forEach(function (key) {
              if (normalizeAttributeName(key) === sizeKey) {
                delete selectedChoices[key];
              }
            });
            root.querySelectorAll('.cw-design-editor__choice-btn, [data-cw-product-size]').forEach(function (el) {
              el.classList.remove('is-active');
            });
            if (sizeTriggerValue) {
              sizeTriggerValue.textContent = (cfg.i18n && cfg.i18n.chooseSizePlaceholder) || 'Wybierz rozmiar';
            }
          }
        }
      }
      // W danej grupie UI może być aktywna tylko jedna opcja naraz.
      root.querySelectorAll(groupSelector).forEach(function (item) {
        item.classList.remove('is-active');
      });
      button.classList.add('is-active');
      refreshChoiceAvailability();
      updateActiveVariant();
      if (typeof afterSelect === 'function') {
        afterSelect();
      }
    });
  }

  root.querySelectorAll('.cw-design-editor__color-btn, [data-cw-product-color]').forEach(function (button) {
    handleChoiceClick(button, '.cw-design-editor__color-btn, [data-cw-product-color]', function () {
      if (button.getAttribute('aria-disabled') === 'true' || button.closest('.cw-design-editor__swatches--single-static')) {
        return;
      }
      var hex = button.getAttribute('data-cw-hex') || '#f8fafc';
      var label = button.getAttribute('aria-label') || 'Kolor';
      setMobileProductColor(hex, label);
      var colorVal = button.getAttribute('data-cw-value') || button.getAttribute('data-cw-color') || '';
      filterProductViewsByColor(colorVal);
      if (isMobileEditorViewport()) {
        closeMobileTopClouds();
      }
    });
  });

  root.querySelectorAll('.cw-design-editor__choice-btn, [data-cw-product-size]').forEach(function (button) {
    handleChoiceClick(button, '.cw-design-editor__choice-btn, [data-cw-product-size]', function () {
      updateSizeTriggerLabel(button);
      closeEditorDropdowns();
      if (isMobileEditorViewport()) {
        closeProductSheet();
      }
    });
  });

  root.querySelectorAll('[data-cw-product-view]').forEach(function (button) {
    button.addEventListener('click', function () {
      var src = button.getAttribute('data-cw-src') || '';
      var nextViewKey = src || 'default';
      if (nextViewKey === currentViewKey) {
        return;
      }
      saveCurrentViewState();
      if (src) {
        setProductImageSrc(src, function () {
          currentViewKey = nextViewKey;
          restoreViewState(currentViewKey);
          setActiveButton(button, '[data-cw-product-view]');
          syncViewDots();
        });
      } else {
        currentViewKey = nextViewKey;
        restoreViewState(currentViewKey);
        setActiveButton(button, '[data-cw-product-view]');
        syncViewDots();
      }
    });
  });

  function activeProductViewIndex() {
    var buttons = visibleProductViewButtons();
    var activeIndex = buttons.findIndex(function (button) {
      return button.classList.contains('is-active');
    });
    return activeIndex >= 0 ? activeIndex : 0;
  }

  function selectProductView(index) {
    var buttons = visibleProductViewButtons();
    if (!buttons.length) {
      return;
    }
    var nextIndex = (index + buttons.length) % buttons.length;
    buttons[nextIndex].click();
  }

  function syncViewDots() {
    var buttons = visibleProductViewButtons();
    var activeBtn = buttons.find(function (button) {
      return button.classList.contains('is-active');
    });
    var activeGalleryIdx = activeBtn ? parseInt(activeBtn.getAttribute('data-cw-gallery-index'), 10) : 0;
    if (isNaN(activeGalleryIdx)) {
      activeGalleryIdx = 0;
    }
    root.querySelectorAll('.cw-design-editor__view-dots span').forEach(function (dot, index) {
      if (dot.hidden) {
        dot.classList.remove('is-active');
        return;
      }
      dot.classList.toggle('is-active', index === activeGalleryIdx);
    });
  }

  root.querySelectorAll('[data-cw-view-nav]').forEach(function (button) {
    button.addEventListener('click', function () {
      var direction = button.getAttribute('data-cw-view-nav') === 'prev' ? -1 : 1;
      selectProductView(activeProductViewIndex() + direction);
    });
  });

  function closeEditorDropdowns(exceptDropdown) {
    root.querySelectorAll('[data-cw-editor-dropdown]').forEach(function (wrap) {
      if (exceptDropdown && wrap === exceptDropdown) {
        return;
      }
      wrap.classList.remove('is-open');
      var menu = wrap.querySelector('[data-cw-dropdown-menu]');
      var trigger = wrap.querySelector('[data-cw-dropdown-trigger]');
      if (menu) {
        menu.hidden = true;
      }
      if (trigger) {
        trigger.setAttribute('aria-expanded', 'false');
      }
    });
  }

  function openEditorDropdown(wrap) {
    closeEditorDropdowns(wrap);
    wrap.classList.add('is-open');
    var menu = wrap.querySelector('[data-cw-dropdown-menu]');
    var trigger = wrap.querySelector('[data-cw-dropdown-trigger]');
    if (menu) {
      menu.hidden = false;
    }
    if (trigger) {
      trigger.setAttribute('aria-expanded', 'true');
    }
  }

  function toggleEditorDropdown(wrap) {
    if (wrap.classList.contains('is-open')) {
      closeEditorDropdowns();
    } else {
      openEditorDropdown(wrap);
    }
  }

  function updateSizeTriggerLabel(button) {
    if (!sizeTriggerValue || !button) {
      return;
    }
    var label = button.getAttribute('data-cw-size-label') || button.textContent || '';
    label = String(label).trim();
    if (label) {
      sizeTriggerValue.textContent = label;
    }
  }

  function setEditorQuantity(qty, displayLabel, markConfirmed) {
    var n = parseInt(qty, 10);
    if (isNaN(n) || n < 1) {
      n = 1;
    }
    if (n > 999) {
      n = 999;
    }
    editorQuantity = n;
    if (markConfirmed !== false) {
      editorQuantityConfirmed = true;
    }
    if (qtyTriggerValue) {
      qtyTriggerValue.textContent = displayLabel != null ? String(displayLabel) : String(n);
    }
    root.querySelectorAll('[data-cw-editor-qty]').forEach(function (btn) {
      var v = btn.getAttribute('data-cw-editor-qty');
      btn.classList.toggle('is-active', v === String(n));
    });
    if (n > 5 && qtyCustomWrap) {
      qtyCustomWrap.classList.add('is-custom-active');
    } else if (qtyCustomWrap) {
      qtyCustomWrap.classList.remove('is-custom-active');
    }
    var previewVariation = matchingVariation(false);
    if (previewVariation) {
      updateSummaryPriceDisplay(previewVariation);
    }
    refreshAddToCartState();
  }

  function applyDefaultProductColorChoice() {
    if (!productNeedsColorChoice() || isColorSelected()) {
      return;
    }
    var first = root.querySelector('[data-cw-product-color]');
    if (!first) {
      return;
    }
    var attribute = normalizeAttributeName(first.getAttribute('data-cw-attribute') || ATTRIBUTE_KEYS.color);
    var value = first.getAttribute('data-cw-value') || first.getAttribute('data-cw-color') || '';
    if (!attribute || !value) {
      return;
    }
    selectedChoices[attribute] = value;
    root.querySelectorAll('.cw-design-editor__color-btn, [data-cw-product-color]').forEach(function (btn) {
      var btnVal = btn.getAttribute('data-cw-value') || btn.getAttribute('data-cw-color') || '';
      btn.classList.toggle('is-active', normalizeAttributeValue(btnVal) === normalizeAttributeValue(value));
    });
    setMobileProductColor(first.getAttribute('data-cw-hex') || '#f8fafc', first.getAttribute('aria-label') || 'Kolor');
    filterProductViewsByColor(value);
  }

  root.querySelectorAll('[data-cw-editor-dropdown]').forEach(function (wrap) {
    var trigger = wrap.querySelector('[data-cw-dropdown-trigger]');
    if (!trigger) {
      return;
    }
    trigger.addEventListener('click', function (event) {
      event.stopPropagation();
      toggleEditorDropdown(wrap);
    });
  });

  root.addEventListener('click', function (event) {
    if (!event.target.closest('[data-cw-editor-dropdown]')) {
      closeEditorDropdowns();
    }
  });

  root.querySelectorAll('[data-cw-editor-qty]').forEach(function (btn) {
    btn.addEventListener('click', function (event) {
      event.stopPropagation();
      var v = btn.getAttribute('data-cw-editor-qty');
      setEditorQuantity(v);
      if (qtyCustomFields) {
        qtyCustomFields.hidden = true;
      }
      closeEditorDropdowns();
    });
  });

  var qtyCustomBtn = root.querySelector('[data-cw-editor-qty-custom]');
  if (qtyCustomBtn) {
    qtyCustomBtn.addEventListener('click', function (event) {
      event.stopPropagation();
      var qtyWrap = root.querySelector('[data-cw-editor-dropdown="qty"]');
      if (qtyWrap) {
        openEditorDropdown(qtyWrap);
      }
      if (qtyCustomFields) {
        qtyCustomFields.hidden = !qtyCustomFields.hidden;
      }
      if (qtyCustomInput && qtyCustomFields && !qtyCustomFields.hidden) {
        qtyCustomInput.focus();
        qtyCustomInput.select();
      }
    });
  }

  var qtyApply = root.querySelector('[data-cw-qty-custom-apply]');
  if (qtyApply && qtyCustomInput) {
    qtyApply.addEventListener('click', function () {
      var n = parseInt(qtyCustomInput.value, 10);
      setEditorQuantity(n, String(n));
      if (qtyCustomFields) {
        qtyCustomFields.hidden = true;
      }
      closeEditorDropdowns();
    });
    qtyCustomInput.addEventListener('keydown', function (event) {
      if (event.key === 'Enter') {
        qtyApply.click();
      }
    });
  }

  root.querySelectorAll('[data-cw-cart-action]').forEach(function (wrap) {
    var btn = wrap.querySelector('[data-cw-add-to-cart-btn]');
    wrap.addEventListener('click', function (event) {
      if (!btn || (!btn.disabled && !btn.classList.contains('is-disabled'))) {
        return;
      }
      event.preventDefault();
      event.stopPropagation();
      showCartHints();
      var hintMsg = getAddToCartHintMessage();
      if (hintMsg) {
        setNotice(hintMsg);
      }
    });
    if (btn) {
      btn.addEventListener('mouseenter', function () {
        if (btn.classList.contains('is-disabled')) {
          showCartHints();
        }
      });
      btn.addEventListener('focus', function () {
        if (btn.classList.contains('is-disabled')) {
          showCartHints();
        }
      });
    }
  });

  root.addEventListener('click', function (event) {
    if (!event.target.closest('[data-cw-cart-action]') && !event.target.closest('[data-cw-add-to-cart-btn]')) {
      hideCartHints();
    }
  });

  var textColor = root.querySelector('[data-cw-text-color]');
  if (textColor) {
    textColor.addEventListener('input', function () {
      defaultTextColor = textColor.value || defaultTextColor;
      var activeObject = canvas.getActiveObject();
      if (isTextObject(activeObject)) {
        activeObject.set('fill', defaultTextColor);
        syncTextToolbar(activeObject);
        canvas.requestRenderAll();
      }
    });
    canvas.on('selection:created', function () {
      var activeObject = canvas.getActiveObject();
      if (activeObject && isPrintZoneEditable(activeObject)) {
        applyPrintZoneToEditableObject(activeObject);
      }
      if (isTextObject(activeObject)) {
        normalizeTextObjectFontSize(activeObject);
        if (activeObject.fill) {
          textColor.value = activeObject.fill;
        }
      }
      if (isMobileEditorViewport()) {
        syncTextToolbar(isTextObject(activeObject) ? activeObject : null);
        return;
      }
      syncTextToolbar(activeObject);
    });
    canvas.on('selection:updated', function () {
      var activeObject = canvas.getActiveObject();
      if (activeObject && isPrintZoneEditable(activeObject)) {
        applyPrintZoneToEditableObject(activeObject);
      }
      if (isTextObject(activeObject)) {
        normalizeTextObjectFontSize(activeObject);
        if (activeObject.fill) {
          textColor.value = activeObject.fill;
        }
      }
      if (isMobileEditorViewport()) {
        syncTextToolbar(isTextObject(activeObject) ? activeObject : null);
        return;
      }
      syncTextToolbar(activeObject);
    });
    canvas.on('selection:cleared', function () {
      syncTextToolbar(null);
    });
    canvas.on('mouse:down', function (opt) {
      syncCanvasPointerOffset();
      if (opt && opt.target && isTextObject(opt.target)) {
        opt.target.__cwTouchMoved = false;
      }
    });
    // Mobile: tap w zaznaczony tekst → od razu edycja (klawiatura).
    canvas.on('mouse:up', function (opt) {
      if (!isMobileEditorViewport()) {
        return;
      }
      syncCanvasPointerOffset();
      var target = opt && opt.target;
      if (!isTextObject(target) || target !== canvas.getActiveObject()) {
        return;
      }
      if (opt && opt.e && opt.e.touches && opt.e.touches.length > 1) {
        return;
      }
      if (target.isEditing) {
        return;
      }
      // Krótki delay — po samym zaznaczeniu nie walczymy z gestem drag.
      window.setTimeout(function () {
        if (canvas.getActiveObject() !== target || target.isEditing) {
          return;
        }
        var moved = target.__cwTouchMoved;
        target.__cwTouchMoved = false;
        if (moved) {
          return;
        }
        focusTextEditorInput(target);
        syncTextToolbar(target);
      }, 40);
    });
    canvas.on('object:moving', function (opt) {
      if (opt && opt.target && isTextObject(opt.target)) {
        opt.target.__cwTouchMoved = true;
      }
    });
    canvas.on('mouse:dblclick', function (opt) {
      var target = opt && opt.target;
      if (isTextObject(target)) {
        focusTextEditorInput(target);
        if (isMobileEditorViewport()) {
          syncTextToolbar(target);
        }
      }
    });
  }

  canvas.on('before:render', function () {
    normalizeAllCanvasTextBaselines();
  });

  canvas.on('object:scaling', function (opt) {
    var t = opt.target;
    if (t && isPrintZoneEditable(t)) {
      constrainObjectToPrintZone(t);
    }
    if (!t || t.type === 'activeSelection') {
      return;
    }
    if (!isTextObject(t)) {
      return;
    }
    var eff = clampCwTextFontSize(getEffectiveTextFontPx(t));
    if (textSize) {
      textSize.value = String(eff);
    }
    if (mobileTextSize) {
      mobileTextSize.value = String(eff);
    }
    if (mobileSizeValue) {
      mobileSizeValue.textContent = formatMobileTextSizeLabel(eff);
    }
    if (textSizePxLabel) {
      textSizePxLabel.textContent = eff + ' px';
    }
  });

  canvas.on('object:modified', function (opt) {
    if (cwTextSizeBakeGuard) {
      return;
    }
    var t = opt.target;
    if (t && isPrintZoneEditable(t)) {
      constrainObjectToPrintZone(t);
    }
    if (!t || t.type === 'activeSelection') {
      return;
    }
    if (!isTextObject(t)) {
      return;
    }
    normalizeTextObjectFontSize(t);
    if (canvas.getActiveObject() === t) {
      syncTextToolbar(t);
    }
    canvas.requestRenderAll();
  });

  canvas.on('object:moving', function (opt) {
    if (opt && opt.target && isPrintZoneEditable(opt.target)) {
      constrainObjectToPrintZone(opt.target);
    }
  });

  if (textSize) {
    textSize.addEventListener('input', function () {
      var raw = parseInt(textSize.value, 10);
      var v = clampCwTextFontSize(isNaN(raw) ? defaultAddTextFontSize() : raw);
      if (String(v) !== textSize.value) {
        textSize.value = String(v);
      }
      if (textSizePxLabel) {
        textSizePxLabel.textContent = v + ' px';
      }
      updateActiveText(function (text) {
        text.set({ fontSize: v, scaleX: 1, scaleY: 1 });
      });
    });
  }

  if (mobileTextSize) {
    mobileTextSize.addEventListener('input', function () {
      var raw = parseInt(mobileTextSize.value, 10);
      var v = clampCwTextFontSize(isNaN(raw) ? defaultAddTextFontSize() : raw);
      if (String(v) !== mobileTextSize.value) {
        mobileTextSize.value = String(v);
      }
      if (mobileSizeValue) {
        mobileSizeValue.textContent = formatMobileTextSizeLabel(v);
      }
      if (textSizePxLabel) {
        textSizePxLabel.textContent = v + ' px';
      }
      updateActiveText(function (text) {
        text.set({ fontSize: v, scaleX: 1, scaleY: 1 });
      });
    });
  }

  if (toolbarColor) {
    toolbarColor.addEventListener('input', function () {
      defaultTextColor = toolbarColor.value || defaultTextColor;
      if (textColor) {
        textColor.value = defaultTextColor;
      }
      updateActiveText(function (text) {
        text.set('fill', defaultTextColor);
      });
    });
  }

  if (uploadInput) {
    uploadInput.addEventListener('change', function () {
      var file = uploadInput.files && uploadInput.files[0] ? uploadInput.files[0] : null;
      if (uploadName) {
        uploadName.textContent = file ? file.name : 'lub przeciągnij i upuść tutaj';
      }
      setNotice('');
      if (file) {
        loadUploadedImage();
      }
    });
  }

  root.addEventListener('click', function (event) {
    var fontPick = event.target.closest('[data-cw-font]');
    if (fontPick && root.contains(fontPick)) {
      var activeFont = canvas.getActiveObject();
      if (isTextObject(activeFont) && printZoneLocksFont(activeFont)) {
        setNotice(cfg.i18n && cfg.i18n.zoneFontLocked ? cfg.i18n.zoneFontLocked : 'Wybór czcionki jest wyłączony.');
        return;
      }
      var font = fontPick.getAttribute('data-cw-font') || 'Quicksand';
      updateActiveText(function (text) {
        text.set('fontFamily', font);
      });
      if (textFontPanel && fontPick.closest('[data-cw-text-font-panel]')) {
        textFontPanel.hidden = true;
      }
    }
  });

  function closeMobileTopClouds() {
    root.classList.remove('cw-design-editor--mobile-top-cloud-open');
    root.querySelectorAll('[data-cw-mobile-cloud-wrap]').forEach(function (w) {
      w.classList.remove('is-open');
    });
    root.querySelectorAll('[data-cw-tool="toggle-mobile-color-cloud"], [data-cw-tool="toggle-mobile-more-cloud"]').forEach(function (b) {
      b.setAttribute('aria-expanded', 'false');
    });
  }

  function toggleMobileTopCloud(name, triggerBtn) {
    var wrap = root.querySelector('[data-cw-mobile-cloud-wrap="' + name + '"]');
    if (!wrap || !triggerBtn) {
      return;
    }
    var isOpen = wrap.classList.contains('is-open');
    root.querySelectorAll('[data-cw-mobile-cloud-wrap]').forEach(function (w) {
      w.classList.remove('is-open');
    });
    if (!isOpen) {
      wrap.classList.add('is-open');
      root.classList.add('cw-design-editor--mobile-top-cloud-open');
      triggerBtn.setAttribute('aria-expanded', 'true');
    } else {
      triggerBtn.setAttribute('aria-expanded', 'false');
    }
    root.querySelectorAll('[data-cw-tool="toggle-mobile-color-cloud"], [data-cw-tool="toggle-mobile-more-cloud"]').forEach(function (b) {
      if (b !== triggerBtn) {
        b.setAttribute('aria-expanded', 'false');
      }
    });
    if (!root.querySelector('[data-cw-mobile-cloud-wrap].is-open')) {
      root.classList.remove('cw-design-editor--mobile-top-cloud-open');
    }
  }

  root.addEventListener('click', function (event) {
    var button = event.target.closest('[data-cw-tool]');
    if (!button) {
      return;
    }

    var tool = button.getAttribute('data-cw-tool');
    if (tool === 'undo') {
      undo();
      return;
    }
    if (tool === 'redo') {
      redo();
      return;
    }
    if (tool === 'toggle-mobile-color-cloud') {
      toggleMobileTopCloud('color', button);
      closeAddMenu();
      return;
    }
    if (tool === 'toggle-mobile-more-cloud') {
      toggleMobileTopCloud('more', button);
      closeAddMenu();
      return;
    }
    if (tool === 'close-mobile-top-clouds') {
      closeMobileTopClouds();
      return;
    }
    if (tool === 'close-text-color') {
      textColorPanel.hidden = true;
      return;
    }
    if (tool === 'close-text-font') {
      if (textFontPanel) {
        textFontPanel.hidden = true;
      }
      return;
    }
    if (tool === 'open-custom-text-color') {
      showCustomColorView(!!button.closest('[data-cw-mobile-custom-color-view], [data-cw-mobile-text-palette-view], .cw-design-editor__text-mobile-sheet'));
      return;
    }
    if (tool === 'back-text-palette') {
      showPaletteView(!!button.closest('[data-cw-mobile-custom-color-view], [data-cw-mobile-text-palette-view], .cw-design-editor__text-mobile-sheet'));
      return;
    }
    if (tool === 'toggle-add-menu') {
      toggleAddMenu();
      return;
    }
    if (tool === 'open-upload') {
      closeProductSheet();
      closeAddMenu();
      openUploadModal();
      return;
    }
    if (tool === 'open-product-sheet') {
      openProductSheet();
      closeAddMenu();
      return;
    }
    if (tool === 'close-product-sheet') {
      closeProductSheet();
      return;
    }
    if (tool === 'close-upload') {
      closeUploadModal();
      return;
    }
    if (tool === 'open-size-guide') {
      openSizeGuideModal();
      return;
    }
    if (tool === 'close-size-guide') {
      closeSizeGuideModal();
      return;
    }
    if (tool === 'load-upload') {
      loadUploadedImage();
      return;
    }
    if (tool === 'add-text') {
      closeAddMenu();
      addText({ openKeyboard: false });
      return;
    }
    if (tool === 'add-shape') {
      addShape();
      return;
    }
    if (tool === 'clear') {
      canvas.getObjects().forEach(function (obj) {
        if (!obj.excludeFromExport && !obj.cwBackdrop) {
          undoStack.push({ type: 'delete', object: obj });
          canvas.remove(obj);
        }
      });
      redoStack = [];
      canvas.discardActiveObject();
      canvas.requestRenderAll();
      return;
    }
    if (tool === 'delete-selected') {
      withSelectedObject(function (obj) {
        removeObjectWithUndo(obj);
      });
      return;
    }
    if (tool === 'bring-front') {
      withSelectedObject(function (obj) {
        canvas.bringToFront(obj);
      });
      return;
    }
    if (tool === 'reset-view') {
      canvas.setViewportTransform([1, 0, 0, 1, 0, 0]);
      canvas.setZoom(1);
      canvas.requestRenderAll();
      return;
    }
    if (tool === 'add-to-cart') {
      if (button.classList.contains('is-disabled')) {
        showCartHints();
        var blockedHint = getAddToCartHintMessage();
        if (blockedHint) {
          setNotice(blockedHint);
        }
        return;
      }
      addToCart(button);
    }
  });

  document.addEventListener('click', function (event) {
    if (textColorPanel && !textColorPanel.hidden) {
      if (!textColorPanel.contains(event.target) && !event.target.closest('[data-cw-text-action="color-panel"]')) {
        textColorPanel.hidden = true;
      }
    }
    if (textFontPanel && !textFontPanel.hidden) {
      if (!textFontPanel.contains(event.target) && !event.target.closest('[data-cw-text-action="font"]')) {
        textFontPanel.hidden = true;
      }
    }
  });

  document.addEventListener('keydown', function (event) {
    if (event.key !== 'Escape') {
      return;
    }
    closeUploadModal();
    closeSizeGuideModal();
    if (textFontPanel) {
      textFontPanel.hidden = true;
    }
    if (textColorPanel) {
      textColorPanel.hidden = true;
    }
  });

  if (textToolbarTrack) {
    textToolbarTrack.addEventListener('scroll', updateTextToolbarNav);
    window.addEventListener('resize', updateTextToolbarNav);
  }

  if (textToolbar) {
    textToolbar.addEventListener('click', function (event) {
      var nav = event.target.closest('[data-cw-text-nav]');
      if (nav && textToolbarTrack) {
        var direction = nav.getAttribute('data-cw-text-nav') === 'prev' ? -1 : 1;
        textToolbarTrack.scrollBy({ left: direction * Math.round(textToolbarTrack.clientWidth * 0.6), behavior: 'smooth' });
        return;
      }
      var button = event.target.closest('[data-cw-text-action]');
      var tab = event.target.closest('[data-cw-text-tab]');
      var styleUi = event.target.closest(
        '[data-cw-text-panel], [data-cw-text-swatch], [data-cw-mobile-text-size], [data-cw-tool="open-custom-text-color"], [data-cw-tool="back-text-palette"]'
      );
      if (styleUi && !(button && button.getAttribute('data-cw-text-action') === 'new-text')) {
        exitActiveTextEditing();
      }
      if (tab) {
        exitActiveTextEditing();
        var tabName = tab.getAttribute('data-cw-text-tab');
        textToolbar.querySelectorAll('[data-cw-text-tab]').forEach(function (item) {
          item.classList.toggle('is-active', item === tab);
        });
        textToolbar.querySelectorAll('[data-cw-text-panel]').forEach(function (panel) {
          var active = panel.getAttribute('data-cw-text-panel') === tabName;
          panel.hidden = !active;
          panel.classList.toggle('is-active', active);
        });
        if (textColorPanel) {
          textColorPanel.hidden = true;
        }
        if (textFontPanel) {
          textFontPanel.hidden = true;
        }
        window.requestAnimationFrame(function () {
          try {
            canvas.calcOffset();
          } catch (eTabOff) {}
        });
        return;
      }
      if (!button) {
        return;
      }
      var action = button.getAttribute('data-cw-text-action');
      if (action === 'new-text') {
        startMobileTextWrite();
        return;
      }
      if (action === 'done') {
        var editingText = activeTextObject();
        if (editingText && editingText.isEditing && typeof editingText.exitEditing === 'function') {
          editingText.exitEditing();
        }
        canvas.discardActiveObject();
        syncTextToolbar(null);
        canvas.requestRenderAll();
        return;
      }
      if (action === 'bold') {
        updateActiveText(function (text) {
          text.set('fontWeight', text.fontWeight === 'bold' ? 'normal' : 'bold');
        });
      }
      if (action === 'italic') {
        updateActiveText(function (text) {
          text.set('fontStyle', text.fontStyle === 'italic' ? 'normal' : 'italic');
        });
      }
      if (action === 'underline') {
        updateActiveText(function (text) {
          text.set('underline', !text.underline);
        });
      }
      if (action === 'center') {
        updateActiveText(function (text) {
          text.set('textAlign', 'center');
          text.set('originX', 'center');
          text.set('left', getPrintZonePlacementCenter().left);
        });
      }
      if (action === 'left') {
        updateActiveText(function (text) {
          text.set('textAlign', 'left');
        });
      }
      if (action === 'right') {
        updateActiveText(function (text) {
          text.set('textAlign', 'right');
        });
      }
      if (action === 'color-panel') {
        if (textColorPanel) {
          textColorPanel.hidden = !textColorPanel.hidden;
          if (!textColorPanel.hidden && textFontPanel) {
            textFontPanel.hidden = true;
          }
        }
      }
      if (action === 'font') {
        if (textFontPanel) {
          textFontPanel.hidden = !textFontPanel.hidden;
          if (!textFontPanel.hidden && textColorPanel) {
            textColorPanel.hidden = true;
          }
        }
      }
      if (action === 'duplicate') {
        var active = activeTextObject();
        if (active) {
          active.clone(function (clone) {
            normalizeCanvasTextBaseline(clone);
            normalizeTextObjectFontSize(clone);
            clone.set({ left: active.left + 18, top: active.top + 18 });
            applyPrintZoneToEditableObject(clone);
            canvas.add(clone);
            undoStack.push({ type: 'add', object: clone });
            redoStack = [];
            canvas.setActiveObject(clone);
            syncTextToolbar(clone);
            canvas.requestRenderAll();
          });
        }
      }
      if (action === 'delete') {
        var text = activeTextObject();
        if (text) {
          removeObjectWithUndo(text);
        }
      }
    });
  }

  root.querySelectorAll('[data-cw-text-swatch]').forEach(function (button) {
    button.addEventListener('click', function () {
      var color = button.getAttribute('data-cw-text-swatch') || defaultTextColor;
      applyTextColor(color);
      if (isMobileEditorViewport()) {
        switchTextTab('format');
      }
    });
  });

  if (customColorPicker) {
    customColorPicker.addEventListener('input', function () {
      customHue = parseInt(customColorPicker.value, 10) || 0;
      if (mobileCustomColorPicker) {
        mobileCustomColorPicker.value = String(customHue);
      }
      applyTextColor(hsvToHex(customHue, customSat, customVal));
    });
  }

  if (mobileCustomColorPicker) {
    mobileCustomColorPicker.addEventListener('input', function () {
      customHue = parseInt(mobileCustomColorPicker.value, 10) || 0;
      if (customColorPicker) {
        customColorPicker.value = String(customHue);
      }
      applyTextColor(hsvToHex(customHue, customSat, customVal));
    });
  }

  if (customColorSquare) {
    customColorSquare.addEventListener('pointerdown', function (event) {
      applyCustomSquarePosition(event, customColorSquare);
      customColorSquare.setPointerCapture(event.pointerId);
    });
    customColorSquare.addEventListener('pointermove', function (event) {
      if (event.buttons) {
        applyCustomSquarePosition(event, customColorSquare);
      }
    });
  }

  if (mobileCustomColorSquare) {
    mobileCustomColorSquare.addEventListener('pointerdown', function (event) {
      applyCustomSquarePosition(event, mobileCustomColorSquare);
      mobileCustomColorSquare.setPointerCapture(event.pointerId);
    });
    mobileCustomColorSquare.addEventListener('pointermove', function (event) {
      if (event.buttons) {
        applyCustomSquarePosition(event, mobileCustomColorSquare);
      }
    });
  }

  if (customTextHex) {
    customTextHex.addEventListener('change', function () {
      var value = customTextHex.value.trim();
      if (/^#([0-9A-Fa-f]{6})$/.test(value)) {
        applyTextColor(value.toUpperCase());
      }
    });
  }

  if (mobileCustomTextHex) {
    mobileCustomTextHex.addEventListener('change', function () {
      var value = mobileCustomTextHex.value.trim();
      if (/^#([0-9A-Fa-f]{6})$/.test(value)) {
        applyTextColor(value.toUpperCase());
      }
    });
  }

  var cwEditorResizeTimer;
  var cwEditorLastLayoutW = 0;

  function refreshEditorAfterViewportChange() {
    syncEditorCanvasDisplayScale();
    dedupeBackdropProductImages();
    if (productImageRef) {
      fitProductImage(productImageRef);
      if (typeof productImageRef.setCoords === 'function') {
        productImageRef.setCoords();
      }
    }
    syncPrintZones();
    syncCanvasPointerOffset();
    canvas.requestRenderAll();
    var active = canvas.getActiveObject();
    syncTextToolbar(isTextObject(active) ? active : null);
  }

  function scheduleEditorViewportRefresh() {
    var w = window.innerWidth || 0;
    // Mobile: sama zmiana wysokości = klawiatura — pełny refresh psuje offset kontrolek/panelu.
    if (isMobileEditorViewport() && cwEditorLastLayoutW && Math.abs(w - cwEditorLastLayoutW) < 2) {
      syncCanvasPointerOffset();
      return;
    }
    cwEditorLastLayoutW = w;
    window.clearTimeout(cwEditorResizeTimer);
    cwEditorResizeTimer = window.setTimeout(refreshEditorAfterViewportChange, 100);
  }

  if (window.matchMedia) {
    var cwDesktopMql = window.matchMedia('(min-width: 901px)');
    if (cwDesktopMql.addEventListener) {
      cwDesktopMql.addEventListener('change', refreshEditorAfterViewportChange);
    } else if (cwDesktopMql.addListener) {
      cwDesktopMql.addListener(refreshEditorAfterViewportChange);
    }
  }
  window.addEventListener('resize', scheduleEditorViewportRefresh);

  if (isMobileEditorViewport()) {
    canvas.targetFindTolerance = 28;
  }

  root.addEventListener(
    'touchstart',
    function () {
      if (isMobileEditorViewport()) {
        syncCanvasPointerOffset();
      }
    },
    { passive: true, capture: true }
  );

  if (window.visualViewport) {
    window.visualViewport.addEventListener('resize', function () {
      if (isMobileEditorViewport()) {
        syncCanvasPointerOffset();
      }
    });
    window.visualViewport.addEventListener('scroll', function () {
      if (isMobileEditorViewport()) {
        syncCanvasPointerOffset();
      }
    });
  }

  applyDefaultProductColorChoice();
  if (productNeedsQtyChoice()) {
    setEditorQuantity(1, '1');
  }
  refreshChoiceAvailability();
  setupProductArea();
  updateActiveVariant();
  ensureInitialProductImage();
  window.requestAnimationFrame(function () {
    refreshEditorAfterViewportChange();
    window.requestAnimationFrame(function () {
      refreshEditorAfterViewportChange();
    });
  });
  window.setTimeout(markEditorReady, 1200);
  canvas.requestRenderAll();
})();
